export const NL = {
  preparing_zip: "Zip voorbereiden…",
  compressing: "Comprimeren…",
  info_icon: "Zodra dit als voltooid is gemarkeerd, kunnen geen extra leden meer deelnemen of worden toegevoegd, en alle chatgroepen worden gedeactiveerd. Houd er rekening mee dat het project, samen met alle chatgroepen en gegevens, toegankelijk blijft in een gedeactiveerde staat.",
  mark_is_done: "Weet u zeker dat u het project als voltooid wilt markeren? Zodra dit is gemarkeerd, kunnen geen extra leden meer deelnemen of worden toegevoegd, en alle chatgroepen worden gedeactiveerd. Houd er rekening mee dat het project, samen met alle chatgroepen en gegevens, toegankelijk blijft in een gedeactiveerde staat.",
  mark_not_done: "Weet u zeker dat u het project opnieuw wilt openen? Zodra dit als open is gemarkeerd, kunnen extra leden deelnemen of worden toegevoegd, en alle chatgroepen worden geheractiveerd.",
  mark_as_completed: "Project als voltooid markeren",
  room_completed: "Project voltooid",
  room_members: "Leden van het project",
  deactivated_rooms: "Gedeactiveerde projecten",
  deactivated_chats: "Gedeactiveerde chats",
  completed_rooms: "Voltooide projecten",
  request_to_join_a_room: 'Verzoek om deel te nemen aan het project',
  wants_to_rejoin_room: 'Username wil opnieuw deelnemen aan het project Roomname.',
  invited_you_to_join_room: 'Username heeft je uitgenodigd om deel te nemen aan het project Roomname.',
  restart: "Herstarten",
  update_text: "Er is een nieuwe update beschikbaar. Klik op herstarten om de update te installeren.",
  update_availble: "Update beschikbaar",
  Loading: "Laden...",
  logout: "Uitloggen",
  back: 'Terug',
  company_list: "Bedrijfslijst",
  followers: "Volgers",
  followings: "Volgend",
  article: "Artikel",
  companies: "Bedrijven",
  one_to_one_chat: " Een-op-een chat",
  profile: "Profiel",
  company: "Bedrijf",
  company_selection: "Bedrijfsselectie",
  home: "Home",
  contact: "Contact ",
  add_company: "Bedrijf toevoegen ",
  add_project: "Project toevoegen ",
  capacities: "Capaciteiten ",
  work_area: "Werkgebied",
  company_services: "Bedrijfsservices",
  website: "Website",
  search_contacts: "Zoek contacten",
  add_or_join_a_company: "Bedrijf toevoegen of deelnemen",
  follow: "Volgen",
  following: "Volgend",
  like: "Vind ik leuk",
  company_contacts: "Bedrijfscontact",
  leave_the_company: "Verlaat het bedrijf",
  news: "Nieuws",
  earlier: "Eerder",
  action: "Actie",
  another_action: "Andere actie",
  something_else: "Iets anders",
  search: "Zoeken",
  search_rooms: "Zoek projecten",
  search_articles: "Zoek artikelen",
  contacts: "Contacten",
  suggestions: "Suggesties",
  project_list: "Projectlijst",
  search_results: "Zoekresultaten",
  add_or_join_project: "Project toevoegen of deelnemen",
  details: "Details",
  your_position_within_company:
    "Kies alstublieft uw positie binnen het bedrijf.",
  close_modal: "Sluiten",
  map: "Kaart",
  or: "Of",
  name: "Naam*",
  street: "Straat*",
  house_number: "Huisnummer",
  postal_code: "Postcode",
  city: "Stad*",
  opened_by: "Geopend door:",
  project_No: "Projectnummer: ",
  building_type: "Bouwtype*",
  building_types: "Bouwtype",
  add_join: "Toevoegen/Deelnemen",
  mandatory_fiels: "*verplichte velden",
  invalid_fiels: "Dit veld is verplicht",
  add_or_join_company: "Bedrijf toevoegen of deelnemen",
  name_of_the_company: "Naam van het bedrijf",
  edit_company_details: "Bedrijfsgegevens bewerken",
  branch_of_the_building_industry: "Tak van de bouwindustrie",
  corporate_form: "Rechtsvorm",
  position_within_company: "Positie binnen het bedrijf",
  request_confirmation: "Openstaande projectverzoeken",
  company_e_mail: "Bedrijfs-e-mail",
  type_of_filter: "Typ om te filteren...",
  setting: "Instelling",
  dashboard: "Dashboard",
  settings: "Instellingen",
  views: "Weergaven",
  times_seen: "keer bekeken",
  see_more: "...meer",
  see_less: "...minder",
  in_search: "in zoekopdracht",
  reset_password: "Wachtwoord resetten",
  submit: "Verzenden",
  password: "Wachtwoord",
  email: "E-mail",
  confirm_password: "Bevestig wachtwoord",
  reset_email: "E-mail resetten",
  update: "Bijwerken",
  new_email: "Nieuwe e-mail",
  kjuup_message: "Kjuup Bericht",
  delete_profile: "Profiel verwijderen?",
  my_position: "Mijn positie:",
  add: "toevoegen",
  owner_company_admin: "Bedrijfsbeheerder :",
  owner_company_admin_new: "Bedrijfsbeheerder",
  mutual_contact: "gemeenschappelijk contact",
  mutual_contacts: "gemeenschappelijke contacten",
  co_owner: "Mede-eigenaar",
  managing_director: "Algemeen directeur",
  associate: "Associé",
  secretary: "Secretaris",
  employee: "Werknemer",
  project_manage: "Projectmanager",
  auto_chat_translation: "Automatische chatvertaling",
  translate_room_group_names: "Chatgroepnamen vertalen",
  translate_room_group_names_info: "Indien ingeschakeld worden chatgroepnamen automatisch vertaald naar je interfacetaal.",
  default_view_email: "Standaardweergave: E-mail",
  default_view_email_info: "Wanneer ingeschakeld, wordt het E-Mail tabblad standaard geopend in plaats van Berichten bij het openen van de app.",
  integrate_email_in_messages: "Integrate E-Mail in Messages",
  integrate_email_in_messages_info: "When enabled, emails from all connected accounts will appear alongside your chat messages, sorted by date.",
  language: "Taal",
  english: "Engels",
  german: "Duits",
  french: "Frans",
  italian: "Italiaans",
  change_language: "Taal wijzigen",
  my_companies: "Mijn bedrijven",
  employees: "Werknemers",
  invite_with_a: "Uitnodigen voor Kjuup",
  add_member: "Lid toevoegen",
  add_user: "Gebruiker toevoegen",
  send_location: "Locatie verzenden",
  assign_admin_rights: "Beheerdersrechten aanpassen",
  deactivate_company: "Bedrijf deactiveren",
  remove_employees: "Werknemers verwijderen",
  remove_members: "Leden verwijderen",
  no_user_found: "Geen gebruiker gevonden!",
  approve: "Goedkeuren!",
  deselect_all: "Alles deselecteren",
  select_all: "Alles selecteren",
  translation_on_building_projects: "Vertaling in projecten",
  reported_capacities: "Gerapporteerde services",
  up_to_50m_exact: "Tot 50m exact",
  company_details_service: "Bedrijfsservices",
  company_contact: "Bedrijfscontact",
  invite_with_link: "Uitnodigen voor Kjuup",
  share_link: "Link delen",
  share_company_link: "Link delen",
  qr_code: "QR-code",
  copy_link: "Link kopiëren",
  cancel_link: "Link annuleren",
  who_has_confirmed_services: "Wie heeft uw services bevestigd?",
  projectss: "Projecten",
  add_services: "Services toevoegen",
  services: "Services",
  save_text: "Opslaan",
  share_on: "Delen op:",
  articlen: "Artikel",
  invite_user_to_confirm_service:
    "Nodig gebruikers uit om services voor het bedrijf te bevestigen.",
  link_copied: "Link gekopieerd!",
  email_copied: "E-mail gekopieerd!",
  personal_article: "Persoonlijk artikel",
  company_article: "Bedrijfsartikel",
  characters_remaining: "Resterende tekens",
  optional_information: "Optionele informatie",
  project: "Project",
  projects: "Projecten...",
  abort: "Weggooien",
  preview: "Voorvertoning",
  post: "Plaatsen",
  of: "van",
  remove: "Verwijderen",
  free_capacity: "Vacatureportaal",
  current_status_overview: "Overzicht huidige status",
  report_capacities: "Services rapporteren",
  report_text: "Rapporteren",
  search_capacities: "Zoek aannemers",
  add_project_user: "Projectgebruiker toevoegen",
  media: "Media",
  links: "Links",
  docs: "Documenten",
  featured_products: "Uitgelichte producten...",
  title: "Titel",
  text: "Tekst",
  feed_details: "Feeddetails",
  add_employee: "Werknemer toevoegen",
  latest: "Nieuwste",
  my_projects: "Mijn projecten",
  cancel: "Annuleren",
  continue: "Doorgaan",
  role_in_the_building_industry: "Rol in de bouwindustrie",
  als: "als",
  join: "deelnemen",
  find: "Zoeken",
  request_to_join_a_company: "Verzoek om deel te nemen aan het bedrijf",
  wants_to_join_the_company: "wil deelnemen aan het bedrijf",
  filter_by: "Filteren op",
  ok: "Ok",
  close: "Sluiten",
  weekly_statistics: "Wekelijkse statistieken",
  is_following_you: "volgt u.",
  as: "als",
  has_joined_the: "heeft deelgenomen aan het bedrijf",
  has_looked_at_your_profile: "heeft uw profiel bekeken.",
  time: "Tijd",
  in_searches_in_past_week: "in zoekopdrachten in de afgelopen week.",
  has_liked_your_article: "vond uw artikel leuk.",
  has_published_a_new_article: "heeft een nieuw artikel gepubliceerd.",
  you: "U",
  all_views: "Alle weergaven",
  all_profile_views: "Alle profielweergaven",
  mutual_company: "gemeenschappelijk bedrijf",
  artical_text: "Artikel schrijven...",
  you_have_appeared: "U bent verschenen",
  your_request_at_the_company: "Uw verzoek bij het bedrijf",
  times_you_have_appeared_in_searches: "keer dat u bent verschenen in zoekopdrachten",
  appear_more_often_in_searches: "Vaker verschijnen in zoekopdrachten",
  you_have_been_found: "U bent gevonden",
  improve_profile: "Profiel verbeteren",
  choose_existing_contact_for_single_chat:
    "Kies bestaand contact voor individuele chat:",
  in_order_to_add_new_contacts:
    "Om nieuwe contacten toe te voegen, zoek alstublieft naar nieuwe contacten op de profielpagina.",
  times_in_searches_in_the_last_week:
    "keer in zoekopdrachten in de afgelopen week. Werk uw profiel bij en voeg meer details toe om gemakkelijker gevonden te worden.",
  has_been_confirmed: "is bevestigd.",
  have_joined_the: "hebben deelgenomen aan de  ",
  building_project: " bouwproject.",
  select_with_which_company_you_want_to_connect_to_the_project:
    "Selecteer het bedrijf dat u zult vertegenwoordigen. Dit wordt weergegeven aan andere deelnemers.",
  select_with_which_company_you_want_to_connect_to_the_chat:
    "Selecteer het bedrijf dat u zult vertegenwoordigen. Dit wordt weergegeven aan andere deelnemers.",
  select_internal_section: "Selecteer alstublieft interne sectie",
  select_profile_image: "Selecteer profielafbeelding",
  share_user: "Gebruiker delen",
  contact_sender_message:
    "Deel deze link om een niet-lid van Kjuup uit te nodigen voor Kjuup. Deze link kan door meerdere personen worden gebruikt om zich te registreren.",
  project_sender_message:
    "Deel deze link om een niet-lid van Kjuup uit te nodigen voor het project projectnaam. Deze link kan door meerdere personen worden gebruikt om zich te registreren en deel te nemen aan het project projectnaam in Kjuup.",
  company_sender_message:
    "Deel deze link om een niet-lid van Kjuup uit te nodigen voor het bedrijf bedrijfsnaam. Deze link kan door meerdere personen worden gebruikt om zich te registreren en deel te nemen aan het bedrijf in Kjuup.",
  contact_receivers_message:
    "Uitnodigingslink om deel te nemen aan Kjuup. Klik alstublieft op de link om zich te registreren voor kjuup.",
  iphone: "iPhone:",
  iphone_recivers_message:
    "Als u Kjuup installeert via de Apple App Store, moet u op deze link klikken na een succesvolle download om u te kunnen registreren.",
  project_receivers_message:
    "Uitnodigingslink om deel te nemen aan het project projectnaam in Kjuup. Klik alstublieft op de link om zich te registreren voor Kjuup en deel te nemen aan het project projectnaam.",
  company_receivers_message:
    "Uitnodigingslink voor het bedrijf bedrijfsnaam in Kjuup. Klik alstublieft op de link om zich te registreren voor Kjuup en deel te nemen aan het bedrijf bedrijfsnaam.",
  sign_in: "Inloggen",
  enter_your_email_add: "Voer uw e-mailadres in",
  forgot_password: "Wachtwoord vergeten?",
  dont_have_account: "Heeft u geen account?",
  register: "Registreren",
  get_app: "Download de app",
  registration: "Registratie",
  dep_ing: "Dipl.-Ing.",
  dr: "Dr.",
  dr_ing: "Dr.-Ing.",
  dep_ing_arc: "Dipl.-Ing. Architect",
  prof: "Prof.",
  first_name: "Voornaam",
  last_name: "Achternaam",
  have_an_account: "Heeft u een account?",
  when_register_you_agree: "Bij registratie gaat u akkoord met onze",
  term_of_use: "gebruiksvoorwaarden",
  to: "tot.",
  in_our: "In onze",
  data_policy: "gegevensbeleid",
  they_find_out: "zij ontdekken,",
  we_provide_store_data: "hoe we informatie verzamelen, verwerken en opslaan.",
  leaving_company_text:
    "Wilt u het bedrijf echt verlaten? Wanneer u het bedrijf verlaat, verlaat u ook alle bijbehorende projecten en chatgroepen. U kunt op elk moment opnieuw deelnemen aan deze projecten met een ander bedrijf.",
  delete_profile_text:
    "Wilt u uw profiel echt verwijderen? Wanneer u uw profiel verwijdert, worden alle verbindingen met bedrijven, projecten en chats verwijderd. U kunt op elk moment een nieuw profiel aanmaken.",
  confirm: "Bevestigen",
  reject: "Afwijzen",
  requet_to_leave: "Verzoek om te verlaten",
  choose: "Kiezen",
  your_add_member: "Lid toevoegen",
  if_you: "als u",
  can_not_find: "uw contact hier niet kunt vinden.",
  please_wait: "Even geduld a.u.b..",
  imprint_gtc: "Impressum/Algemene voorwaarden",
  register_confirm_popup: "Bevestig uw Kjuup-e-mailadres voordat u inlogt. We hebben een bevestigingslink gestuurd. Ziet u deze niet, controleer dan ook de spammap.",
  PENDING_GROUP_USER:
    "zal berichten alleen ontvangen nadat de uitnodiging voor het project is bevestigd. Er verschijnt een extra bericht zodra de uitnodiging voor het project is bevestigd.",
  PENDING: "Bevestiging van uitnodiging voor het project in behandeling",
  denied_group_chat: " heeft de uitnodiging voor het project geweigerd en heeft deze groep verlaten.",
  // joined_group_chat: " heeft deelgenomen aan de ruimte en deze groep.",
  joined_group_chat: " heeft deelgenomen aan deze groep",
  you_joined_group_chat: "U heeft deelgenomen aan deze groep.",
  Others: "Anderen",
  LEFT_GROUP: "heeft deze chatgroep verlaten.",
  YOU_LEFT_GROUP: "hebben deze chatgroep verlaten.",
  days: "dagen",
  day: "dag",
  hour: "uur",
  hide_project: "Project verbergen",
  hide_project_popup_text:
    "Als u projecten verbergt, kunnen ze niet worden gevonden binnen Kjuup. Alleen leden van het project kunnen nieuwe gebruikers uitnodigen voor het project.",
  branch: "Tak",
  photo_video_media_lib: "Mediabibliotheek - Foto en video",
  document: "Document",
  location_meeting: "Locatie / Vergadering",
  all_member_of_project: "Alle leden van het project",
  pending_request: "Openstaande projectverzoeken",
  no_pending_request: "Geen openstaande verzoeken gevonden!",
  news_feed: "Nieuwsfeed",
  user_info: "Groepsinformatie",
  leave_project: "Project verlaten",
  media_link_docs: "Bestanden",
  search_chat: "Zoek in chat",
  export_chat_group: "Exporteer chatgroepgegevens van de afgelopen maand",
  request_complete_chat_history: "Volledige chatgeschiedenis opvragen",
  leave_chat_group: "Chatgroep verlaten",
  add_user_project: "Gebruiker toevoegen",
  me: "Ik",
  max_open_one_to_one:
    "Momenteel kunnen max. 2 een-op-een chats parallel worden geopend in het onderste en bovenste gedeelte. In totaal zijn max. 4 een-op-een chats mogelijk.",
  are_you_sure_you_want_leave_chat:
    "Weet u zeker dat u deze chatgroep wilt verlaten?",
  create_group: "Groep aanmaken",
  adding_members: "Leden toevoegen...",
  creating_the_chat: "Chat aanmaken...",
  finishing_setup: "Afronden...",
  group_name: "Groepsnaam",
  by: "Door:",
  mandetory: "*verplicht",
  delteed: "heeft zijn/haar profiel verwijderd en heeft de groepschat verlaten.",
  deleted_direct: "heeft zijn/haar profiel verwijderd en heeft de chat verlaten.",
  unhidden_message:
    "Als u projecten zichtbaar maakt, kunnen ze worden gevonden door alle leden van Kjuup.",
  account_deleted: "Account is verwijderd.",
  refuse_company: "Weet u zeker dat u de bedrijfsuitnodiging wilt weigeren?",
  follow_additional: "Extra gebruikers volgen",
  f_add:
    "Volg extra gebruikers van Kjuup om ze beschikbaar te maken voor directe berichten.",
  c_inv: "Bedrijfsuitnodiging(en)",
  invited_o_Company: "U bent uitgenodigd om deel te nemen aan het bedrijf",
  refuse_companyX: "Weet u zeker dat u het bedrijfsverzoek wilt weigeren?",
  a_Da: "Account gedeactiveerd.",
  has_deactivated: "heeft zijn/haar profiel gedeactiveerd.",
  reactive: "heeft zijn/haar profiel geheractiveerd.",
  juup_note: "*Registratie met gebruikersnaam alleen beschikbaar voor leden van Kjuup+",
  username: "Gebruikersnaam*",
  email_username: "E-mail/Gebruikersnaam*",
  sPinText:
    "Geef alstublieft een 6-cijferige beveiligingspin op. Deze pin is nodig als u uw wachtwoord vergeet en is verplicht om uw account te bevestigen.",
  DeleteKjuupPlusText:
    "Wilt u uw profiel echt verwijderen? Wanneer u uw profiel verwijdert, worden alle verbindingen met bedrijven, projecten en chats verwijderd.\n\nBinnen 48 uur na accountverwijdering kunt u uw account opnieuw activeren door in te loggen met gebruikersnaam, wachtwoord en pin.",
  reactive_text:
    "Uw account is verwijderd. Klik alstublieft op Opnieuw activeren om uw account opnieuw te activeren.",
  rac: "Opnieuw activeren",
  ac_ss: "Account succesvol geheractiveerd.",
  not_valid_pin: "Pin ongeldig",
  only_for_kjuup:
    "*Wachtwoordreset via gebruikersnaam en pin alleen beschikbaar voor leden van Kjuup+.",
  resetPIN: "Pin resetten",
  enter_current_pin: "Voer alstublieft uw huidige pin in",
  enter_new: "Voer nieuwe pin in",
  pin_to_confirm: "Geef alstublieft de pin op om te bevestigen.",
  change_username: "Gebruikersnaam resetten",
  pp_not_match: "Wachtwoord en bevestigingswachtwoord komen niet overeen",
  reactive_itself: "U heeft uw profiel opnieuw geactiveerd.",
  has_deactivated_itself: "U heeft uw profiel gedeactiveerd.",
  more_than_two:
    "Momenteel kunnen directe berichten alleen worden verzonden naar 2 gebruikers parallel.",
  Chats: "Directe berichten",
  only_in_mobileL:
    "Native video's kunnen momenteel alleen worden geüpload en gepost via de mobiele app. Gebruik alstublieft videolinks van Youtube en Vimeo.",
  register_pin_text:
    "Kies alstublieft uw persoonlijke 6-cijferige pin. Deze pin is nodig om accountresetfunctionaliteiten in te schakelen.",
  internal_project: "Intern",
  external_projects: "Extern",
  in_deacticted: "Interne sectie is gedeactiveerd.",
  create_article: "Artikel aanmaken",
  new_article_selection: "Artikel aanmaken voor externe nieuwsfeed",
  new_article_selection_internal: "Intern artikel aanmaken",
  active_trans_title: "Automatische vertaling inschakelen?",
  active_trans: "Wanneer ingeschakeld, worden alle inkomende chatberichten vertaald naar uw geselecteerde app-taal.",
  disable_trans: "Wilt u automatische vertaling echt deactiveren?",
  allow_access_chat: "Volledige chatgeschiedenis tonen",
  toggle_chat_history_on:
    "Wilt u echt dat de gebruiker de volledige chatgeschiedenis ziet?",
  toggle_chat_history_off:
    "Wilt u echt dat de gebruiker alleen de chatgeschiedenis ziet vanaf het moment van deelnemen aan de chat?",
  check_selected_settings:
    "Controleer alstublieft de instellingen voor chatgeschiedenis voor alle geselecteerde gebruikers!",
  chat_from_start_have:
    "U heeft deelgenomen aan deze groep. De chatgeschiedenis is gedeeld.",
  chat_from_start_has:
    "heeft deelgenomen aan deze groep. De chatgeschiedenis is gedeeld.",
  Address: "Adres",
  read_by: "Gelezen door",
  deliver_to: "Afgeleverd aan",
  remaining: "resterend",
  message_info: "Berichtinformatie",
  request_to_join_only: "Verzoek om deel te nemen",
  unfollow: "Ontvolgen",
  company_username: "Gebruikersnaam",
  month: [
    "Jan",
    "Feb",
    "Mrt",
    "Apr",
    "Mei",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Okt",
    "Nov",
    "Dec",
  ],
  remove_my_admin_right: "Mijn beheerdersrechten verwijderen",
  makeEmp: "Wilt u echt de bedrijfsbeheerdersrechten van de gebruiker verwijderen?",
  remove_my_self:
    "Wilt u echt de bedrijfsbeheerdersrechten van uw account verwijderen?",
  makeAdmin: "Wilt u echt de gebruiker bedrijfsbeheerdersrechten geven?",
  remove_member: "Lid verwijderen",
  remove_following_confirm: "Wilt u {name} echt uit de lijst met gevolgde personen verwijderen?",
  remove_follower_confirm: "Wilt u {name} echt uit uw volgers verwijderen? Als u hem/haar verwijdert, wordt hij/zij niet op de hoogte gesteld.",
  do_you_really_want_to_remove:
    "Wilt u echt de gebruikersnaam van het bedrijf verwijderen?",
  invite_all: "Nodig alle leden van het bedrijf uit",
  invite_all_members: "Nodig alle leden uit",
  mems: "Alle andere leden",
  dep_loc: "Afdeling/Locatie/Team",
  depAdmin: "Afdelingbeheerder",
  add_remove_admin: "Bedrijfsbeheerderpositie toevoegen/verwijderen",
  add_remove_dep_admin: "Afdelingbeheerderpositie toevoegen/verwijderen",
  remove_employees_dept: "Werknemers verwijderen van",
  want_to_join_dep:
    "Gebruikersnaam wil deelnemen aan de Afdeling/Locatie/Team depname van het bedrijf bedrijfsnaam.",
  you_invited:
    "U bent uitgenodigd om deel te nemen aan de Afdeling/Locatie/Team depname van het bedrijf bedrijfsnaam.",
  dep_remove:
    "Wilt u echt de beheerdersrechten voor afdeling of locatie van de gebruiker verwijderen?",
  add_dep:
    "Wilt u echt de gebruiker beheerdersrechten voor de afdeling of locatie geven?",
  my_self_dep_remove:
    "Wilt u echt de afdelingbeheerdersrechten van uw account verwijderen?",
  member: "Lid",
  admin: "Beheerder",
  remove_project_admin:
    "Wilt u echt het lid van het project verwijderen?",
  remove_my_self_project: "Wilt u echt de beheerdersrechten verwijderen?",
  remove_member_admin_right:
    "Wilt u echt de beheerdersrechten van de gebruiker verwijderen?",
  add_member_admin_right: "Wilt u echt beheerdersrechten aan de gebruiker toevoegen?",
  add_remove_Poss: "Beheerderpositie toevoegen/verwijderen",
  forward: "Doorsturen",
  forward_to: "Doorsturen naar...",
  edit: "Bewerken",
  only_kjuup_plus_can: "Alleen Kjuup+ bedrijven kunnen artikelen plaatsen.",
  add_images: "Afbeelding(en) toevoegen",
  request_confirmation: 'Openstaande projectuitnodigingen',
  Activity: "Activiteit",
  latest_messages: "Laatste berichten",
  hours: "uren",
  minute: "minuten",
  seconds: "seconden",
  days: "dagen",
  yesterday: "gisteren",
  last_week: "vorige week",
  next_week: "volgende week",
  Last_month: "vorige maand",
  All: "Alles",
  register_plus: "Registratie Plus",
  select_files: "Bestanden selecteren",
  monthsFullName: [
    "Januari",
    "Februari",
    "Maart",
    "April",
    "Mei",
    "Juni",
    "Juli",
    "Augustus",
    "September",
    "Oktober",
    "November",
    "December",
  ],
  company_deploc_receivers_message:
    "Uitnodigingslink voor de afdeling van het bedrijf bedrijfsnaam in Kjuup. Klik alstublieft op de link om zich te registreren voor Kjuup en deel te nemen aan het bedrijf bedrijfsnaam.",
  no_news: "Geen nieuws beschikbaar",
  reminder: "Herinnering",
  np_reminder: "Geen taken",
  move_to_reminder: "Verplaats naar taak",
  remove_reminder: "Wilt u dit bericht echt verwijderen uit de lijst van uw taken?",
  remove_all_reminder: "Verwijder alle taken",
  remove_all_confirm: "Wilt u alle berichten echt verwijderen uit de lijst van uw taken?",
  remove_from_reminder: "Verwijder uit herinnering",
  prevent_email: "E-mail kan niet worden gebruikt als gebruikersnaam.",
  allow_noti: "Sta alstublieft meldingen toe.",
  join_cap: "Deelnemen",
  pass_minimum:
    "**Wachtwoord vereist 12 tekens incl. kleine letter, hoofdletter, cijfer en speciaal teken.",
  pass_error: "Controleer alstublieft de wachtwoordvereisten",
  people_that_like_article: "Mensen die het artikel leuk vinden.",
  people_who_like_article: "Mensen die uw artikel leuk vinden.",
  message_delete: "Dit bericht is verwijderd.",
  message_edited: "bewerkt",
  edit_message: "Bericht bewerken",
  edit_window_expired: "Berichten kunnen alleen binnen 10 minuten na het verzenden worden bewerkt.",
  message_edit_save: "Opslaan",
  copy: "Kopiëren",
  bookmark: "Bladwijzer",
  add_reaction: "Reactie toevoegen",
  delete_message: "Bericht verwijderen",
  more_options: "Meer opties",
  info: "Info",
  link_invite: "Uitnodigen via link",
  ll_nkk: "Uitnodigen voor Kjuup",
  selected: "Geselecteerd",
  is_active: "Actief",
  inactive: "Inactief",
  last_online: "laatst online {{when}}",
  remove_user_l: "Verwijderen",
  link_expire: "Elke gegenereerde link is 72 uur geldig.",
  company_language: "Bedrijfstaal",
  company_language_info:
    "De taalselectie wordt gebruikt voor alle e-mailbevestigingen met betrekking tot het bedrijf.",
  s_image: "afbeelding",
  m_image: "afbeeldingen",
  removeMsg: "Tik om te verwijderen",
  block: 'Blokkeren',
  unblock: 'Deblokkeren',
  blocks: 'Weet u zeker dat u deze gebruiker wilt blokkeren?',
  unblocks: 'Weet u zeker dat u deze gebruiker wilt deblokkeren?',
  bolcked_click_un_block:
    'U heeft dit contact geblokkeerd. Klik hier om de blokkering te verwijderen.',
  you_have_unblocked: 'U heeft dit contact gedeblokkeerd.',
  you_have_blocked: 'U heeft dit contact geblokkeerd.',
  unblock_to_send: 'Deblokkeer gebruiker om bericht te verzenden.',
  pilot_text: "Gespecialiseerde AI voor bouwonderwerpen",
  startup_screen_label: "Startscherm",
  startup_screen_info: "Kies welk scherm opent bij het starten van Kjuup.",
  startup_screen_feed: "Home",
  startup_screen_messages: "Berichten",
  startup_screen_saved: "Startscherm bijgewerkt",
email_on: "E-mailmeldingen chats",
  email_on_grp: "E-mailmelding",
  article_email_on: "E-mailmeldingen artikelen",
  article_email_info: "Als u e-mailmeldingen voor interne artikelen inschakelt, ontvangt u een e-mail wanneer een nieuw intern artikel in uw bedrijf en afdeling wordt gepubliceerd.",
  info_email_room: "Activeer of deactiveer e-mailmeldingen voor dit project. Deze optie is alleen beschikbaar wanneer \"E-mailmeldingen chats\" is ingeschakeld via persoonlijke instellingen.",
  todo_notification_info: "Je ontvangt een melding zodra er een nieuwe ToDo aan je wordt toegewezen.",
  info_val: "Je ontvangt een e-mail als een nieuw chatbericht niet binnen korte tijd wordt gelezen. Je kunt dit uitschakelen voor specifieke projecten of chats in hun instellingen of in de chatgroepinformatie.",
  email_groups: "Activeer of deactiveer e-mailmeldingen voor deze chat. Deze optie is alleen beschikbaar wanneer \"E-mailmeldingen chats\" is ingeschakeld via persoonlijke en projectinstellingen.",
  add_update_email: "E-mail toevoegen/bijwerken",
  text_to_verifiy: "De optie \"E-mailmeldingen chats\" kan alleen worden ingeschakeld als u een geverifieerd e-mailadres in het bestand heeft.",
  stored_email: "Opgeslagen e-mail: ",
  verify_email: "Bevestiging in behandeling!",
  join_call:"Deelnemen",
  call_is_started:"Oproep gestart",
  start_chat:"Directe chat starten?",
  project_rooms:"Projecten",
  download_selected:"Downloaden",
  add_employee_confirm: 'Weet u zeker dat u deze gebruiker aan het bedrijf wilt toevoegen?',
  invalid_deeplink: "Ongeldige deep link URL. Ontbrekende vereiste parameters.",
  deeplink_error: "Kan deep link niet verwerken. Probeer het later opnieuw.",
  // Reply functionality translations
  reply: "Antwoorden",
  reply_enter: "Voer antwoord in...",
  reply_sent_successfully: "Antwoord succesvol verzonden",
  reply_failed: "Antwoord verzenden mislukt",
  reply_failed_generic: "Antwoord verzenden mislukt. Probeer het opnieuw.",
  replying_to_message: "Antwoorden op bericht",
  cancel_reply: "Antwoord annuleren",
  voice_message: "Spraakbericht",
  send: "Verzenden",
  cancel: "Annuleren",
  type_your_reply: "Typ uw antwoord...",
  
  // Auto-suggestion translations
  suggested_replies: "Voorgestelde antwoorden",
  suggestions_error: "Suggests laden mislukt",
  positive_suggestion_placeholder: "Positive",
  neutral_suggestion_placeholder: "Neutral",
  negative_suggestion_placeholder: "Negative",
  lazy_media_image: "Afbeelding — Klik om te laden",
  lazy_media_audio: "Spraakbericht — Klik om te laden",
  lazy_media_doc: "Document — Klik om te laden",
  lazy_media_video: "Video — Klik om te laden",
  suggestion_loading_message: "Een moment. Uw tekst wordt individueel voor u voorbereid.",
  loading_chat_message: "Chat laden...",
  
  // Manual ToDo translations
  extracting_message: "Bericht extraheren...",
  create_todo: "Taak aanmaken",
  create_todo_confirmation: "Wilt u een taak maken van dit bericht?",
  select_project_required: "Selecteer alstublieft een project/groep",
  only_assigned_can_change_status: "Alleen toegewezen gebruikers kunnen de status wijzigen",
  todo_summary: "Samenvatting",
  todo_summary_placeholder: "Voer taaksamenvatting in...",
  todo_date: "Datum",
  todo_time: "Tijd",
  todo_date_hint: "Laat leeg om de originele berichtdatum/tijd te gebruiken",
  todo_created_success: "Taak succesvol aangemaakt",
  todo_creation_failed: "Taak aanmaken mislukt",
  create: "Aanmaken",
  
  image: "afbeelding",
  images: "afbeeldingen",
  remove_all_images: "Verwijder alle afbeeldingen",
  remove_image: "Verwijder afbeelding",
  remove_document: "Verwijder document",
  remove_recording: "Verwijder opname",
  play_recording: "Opname afspelen",
  upload_image: "Afbeelding uploaden",
  upload_document: "Document uploaden",
  record_audio: "Audio opnemen",
  stop_recording: "Opname stoppen",
  stop_recording_text: "Opname stoppen",
  please_remove_current_attachment: "Verwijder alstublieft het huidige bijlage om",
  please_upload_image_file: "Upload alstublieft een geldig afbeeldingsbestand",
  please_upload_valid_document: "Upload alstublieft een geldig documentbestand",
  searching_messages: "Berichten zoeken...",
  loading_more: "Meer laden...",
  loading_more_users: "Meer gebruikers laden...",
  load_more_users: "Meer gebruikers laden",
  no_more_users_to_load: "Geen gebruikers meer om te laden",
  no_messages_found: "Geen berichten gevonden",
  try_different_keyword: "Probeer een ander trefwoord of controleer uw spelling.",
  search_messages: "Zoek berichten, chatgroepen, projecten en gebruikers...",
  todo: "Taak",
  np_todo: "Geen taken",
  move_to_todo: "Opslaan als taak",
  remove_todo: "Wilt u de taak echt verwijderen?",
  remove_all_todo: "Verwijder alle taken",
  remove_all_todo_confirm: "Wilt u alle taken echt verwijderen?",
  add_to_todo: "Toevoegen aan taak",
  remove_from_todo: "Verwijder uit taak",
  confirm: "Bevestigen",
  ok: "Ok",
  read_more: "Lees meer",
  show_less: "Toon minder",
  show_more: "Toon meer",
  audio: "Audio",
  video: "Video",
  // Notification Settings
  notification_schedule: "Meldingsschema",
  notification_schedule_desc: "U ontvangt alleen push- en e-mailmeldingen in de uren die u kiest. Buiten die tijden worden ze gepauzeerd.",
  learn_more: "Meer informatie",
  allow_notifications: "Meldingen toestaan:",
  every_day: "Elke dag",
  weekdays: "Werkdagen (maandag t/m vrijdag)",
  custom: "Aangepast",
  monday: "Maandag",
  tuesday: "Dinsdag",
  wednesday: "Woensdag",
  thursday: "Donderdag",
  friday: "Vrijdag",
  saturday: "Zaterdag",
  sunday: "Zondag",
  to: "tot",
  notification_settings: "Meldingen",
  notification_settings_saved: "Meldingsinstellingen succesvol opgeslagen",
  notification_settings_error: "Meldingsinstellingen opslaan mislukt",
  unavailability_note: "Afwezigheidsbericht",
  unavailability_description: "Stel een afwezigheidsbericht in. Zolang het actief is, wordt het bericht getoond aan anderen in al uw chats en worden meldingen gepauzeerd.",
  unavailability_start_date: "Startdatum",
  unavailability_end_date: "Einddatum",
  unavailability_message: "Bericht",
  unavailability_message_hint: "Gebruik {endDate} als tijdelijke aanduiding voor uw terugkeerdatum.",
  unavailability_replacement: "Vervangend contact",
  unavailability_replacement_placeholder: "Voer gebruikers-ID in voor dringende verzoeken",
  unavailability_replacement_current: "Huidige vervanging",
  unavailability_replacement_hint: "Indien ingesteld, wordt een link getoond om deze persoon te contacteren voor dringende zaken in uw afwezigheidsbericht.",
  unavailability_replacement_none: "Geen vervanging (optioneel)",
  unavailability_contact_urgent: "Voor dringende verzoeken neem contact op met",
  unavailability_default_message: "Ik ben momenteel niet op kantoor en heb geen toegang tot Kjuup. Vanaf {endDate} ben ik weer bereikbaar en neem ik contact met u op.",
  unavailability_save: "Opslaan",
  unavailability_deactivate: "Deactiveren",
  unavailability_active_until: "Actief tot",
  unavailability_saved: "Afwezigheidsbericht opgeslagen",
  unavailability_save_error: "Fout bij het opslaan van het afwezigheidsbericht",
  unavailability_deactivated: "Afwezigheidsbericht gedeactiveerd",
  unavailability_end_date_required: "Einddatum is verplicht",
  start_time_before_end_time: "Starttijd moet vóór eindtijd zijn",
  loading: "Laden",
  disabled: "Uitgeschakeld",
  enable: "Inschakelen",
  disable: "Uitschakelen",
  forwarded: "Doorgestuurd",
  message_forwarded: "Bericht doorgestuurd!",
  // Schedule Article
  schedule_article_post: "Artikelpublicatie plannen",
  date: "Datum",
  time: "Tijd",
  scheduled_for_publication: "Gepland voor publicatie",
  article_will_be_published_on: "Het artikel wordt gepubliceerd op:",
  reset_selection: "Selectie resetten",
  continue: "Doorgaan",
  cancel: "Annuleren",
  // Member Selection
  error_loading_members: "Fout bij het laden van leden",
  please_fill_all_fields: "Vul alstublieft alle velden in",
  invalid_email: "Ongeldig e-mailadres",
  member_added_successfully: "Lid succesvol toegevoegd",
  error_onboarding_user: "Fout bij het toevoegen van gebruiker",
  error_creating_chat: "Fout bij het aanmaken van chat",
  error_creating_group: "Fout bij het aanmaken van groep",
  new_group: "Nieuwe groep",
  please_select_or_enter_group_name: "Selecteer alstublieft een groep of voer een groepsnaam in",
  please_select_or_enter_room_name: "Selecteer alstublieft een project of voer een projectnaam in",
  error_creating_room: "Fout bij het aanmaken van project",
  error_opening_chat: "Fout bij het openen van chat",
  privacy_modal_text: "Selecteer \"Privé\" alleen als de chat geen relevante professionele inhoud voor de projectmanager bevat.",
  not_private: "Niet privé",
  private: "Privé",
  error_loading_groups: "Fout bij het laden van groepen",
  automatic_chat_export: "Automatische chatexport",
  automatic_chat_export_info: "Na activering wordt de chatgeschiedenis automatisch elke maand naar het opgegeven e-mailadres verzonden.",
  automatic_chat_export_no_email: "Om automatische chatexport in te schakelen, moet je eerst een e-mailadres toevoegen. Je kunt je e-mailadres toevoegen in de persoonlijke instellingen.",
  enter_email: "Voer e-mail in",
  update: "Bijwerken",
  confirm: "Bevestigen",
  export_to_email: "De export gaat naar de volgende e-mail.",
  start_chat_button:"Nieuw bericht",
  matching_existing_chats: "Overeenkomende bestaande chats",
  subject: "Onderwerp",
  add_subject: "Onderwerp toevoegen",
  chat_subject: "Chatonderwerp:",
  set_project_room: "Project instellen",
  matching_existing_project_rooms: "Overeenkomende bestaande projecten",
  name_project_room: "Project benoemen",
  professional_or_private: "Professioneel of privé",
  professional: "Professioneel",
  privacy_modal_text_updated: "Selecteer \"Privé\" alleen als de chat geen relevante professionele inhoud voor projectmanagers bevat. Privéchats zijn niet zichtbaar voor projectmanagers.",
  create_internal_chat: "Externe - of interne chat?",
  internal_chat_description: "Alleen werknemers van uw bedrijf kunnen worden toegevoegd aan interne chats.",
  yes: "Ja",
  no: "Nee",
  chat_is_being_created: "Chat wordt aangemaakt...",
  // Additional translations for hardcoded text
  discard_article_confirm: "Wilt u de wijzigingen aan dit artikel echt verwerpen?",
  please_enter_article_title: "Voer alstublieft eerst de artikeltitel in.",
  please_add_mandatory_fields: "Voeg alstublieft alle verplichte velden toe",
  product_label: "Product:",
  no_companies_found: "Geen bedrijven gevonden",
  visible_to_all_followers: "Zichtbaar voor alle Kjuup-leden",
  only_visible_to_employees: "Alleen zichtbaar voor werknemers",
  something_went_wrong: "Er is iets misgegaan, probeer het opnieuw",
  please_select_department: "Selecteer alstublieft afdeling/locatie",
  schedule: "Plannen",
  please_select_future_date_time: "Selecteer alstublieft een toekomstige datum en tijd om het artikel te plannen.",
  please_select_different_date_time: "Selecteer alstublieft een andere datum of tijd om het artikel te plannen.",
  please_select_later_time: "Selecteer alstublieft een tijd later dan de huidige tijd voor vandaag.",
  unpin_article: "Artikel losmaken",
  pin_article: "Artikel vastmaken",
  and: "en",
  others: "anderen",
  at: "om",
  // Chat mute/unmute translations
  mute: "Dempen",
  unmute: "Geluid aanzetten",
  chat_muted_successfully: "Chat succesvol gedempt",
  chat_unmuted_successfully: "Chatgeluid succesvol aangezet",
  mute_chat_confirm: "Wilt u deze chat echt dempen? U ontvangt geen meldingen meer voor nieuwe berichten.",
  unmute_chat_confirm: "Wilt u het geluid van deze chat echt aanzetten? U ontvangt weer meldingen voor nieuwe berichten.",
  please_select_group_to_forward: "Selecteer alstublieft groep om bericht door te sturen",
  // Company translations
  record_not_found: "Record niet gevonden!",
  please_select_position: "Selecteer alstublieft positie",
  delete_article_confirm: "Weet u zeker dat u dit artikel wilt verwijderen?",
  delete_company_service_confirm: "Weet u zeker dat u de bedrijfsservice wilt verwijderen?",
  block_translation_confirm: "Wilt u automatische vertaling in projecten echt blokkeren voor alle leden van het bedrijf",
  unblock_translation_confirm: "Wilt u automatische vertaling in projecten echt deblokkeren voor alle leden van het bedrijf",
  please_select_file: "Selecteer alstublieft een bestand om te uploaden",
  role_in_building_industry: "Rol in de bouwindustrie*",
  invalid_email_address: "Ongeldig e-mailadres",
  please_enter_password: "Voer alstublieft wachtwoord in",
  password_change_email_sent: "Er is een e-mail verzonden naar uw Kjuup e-mailadres. Bevestig uw nieuwe wachtwoord door op de bevestigingslink in de e-mail te klikken.",
  please_enter_username: "Voer alstublieft gebruikersnaam in",
  username_same_as_before: "Gebruikersnaam kan niet hetzelfde zijn als voorheen",
  profile_deleted_successfully: "Profiel succesvol verwijderd",
  hardware_requirements: "Hardwarevereisten",
  hardware_requirements_list: "• 4GB RAM<br/>• CPU-snelheid min. 2GHz<br/>• Windows 7 of hoger / alle macOS-versies",
  submitting: "Verzenden...",
  signing_in: "Inloggen...",
  please_enter_service_name: "Voer alstublieft servicenaam in",
  something_went_wrong_error: "Aaaah! Er is iets misgegaan...",
  something_went_wrong_try_again: "Sorry, er is iets misgegaan. Probeer het opnieuw",
  position_label: "Positie:",
  loading_room: "Project laden...",
  navigating_to_room: "Navigeren naar het project",
  loading_chat: "Chat laden...",
  translate: "Vertalen",
  show_original: "Origineel tonen",
  saving: "Opslaan...",
  language_selection_info: "De taalselectie wordt gebruikt voor alle e-mailbevestigingen met betrekking tot het bedrijf.",
  // Navigation bar labels
  nav_call: "Bellen",
  nav_home: "Home",
  nav_messages: "Berichten",
  nav_todo: "Taken",
  nav_rooms: "Projecten",
  nav_all_rooms: "Alle projecten",
  pinned_rooms_max: "Je kunt maximaal 10 projecten vastzetten.",
  pinned_room_unpin: "Losmaken",
  pinned_rooms_drop: "Sleep je project hierheen voor snelle selectie",
  nav_profile: "Profiel",
  nav_company: "Bedrijf",
  nav_company_documents: "Documenten",
  nav_logout: "Uitloggen",
  // Create message dialog
  add_member_title: "Lid toevoegen",
  continue_btn: "Doorgaan",
  search_placeholder: "Zoeken",
  no_members_found: "Geen leden gevonden",
  no_groups_found: "Geen groepen gevonden",
  no_rooms_found: "Geen projecten gevonden",
  search_users_tab: "Gebruikers",
  search_documents_tab: "Documenten",
  company_documents: "Company documents",
  company_documents_empty: "No documents available.",
  no_media_available: "Geen bestanden",
  no_documents_available: "No documents",
  searching_users: "Gebruikers zoeken...",
  no_users_found: "Geen gebruikers gevonden",
  search_emails_tab: "E-mail",
  searching_emails: "E-mails zoeken...",
  no_emails_found: "Geen e-mails gevonden",
  search_email_addresses_tab: "E-mailadressen",
  search_email_content_tab: "E-mailinhoud",
  searching_email_content: "E-mailinhoud zoeken...",
  no_email_content_found: "Geen e-mailinhoud gevonden",
  search_email_attachments_tab: "Bijlagen",
  searching_email_attachments: "Bijlagen zoeken...",
  no_email_attachments_found: "Geen bijlagen gevonden",
  email_attachments_label: "Bijlagen",
  searching_email_addresses: "Adressen zoeken...",
  no_email_addresses_found: "Geen adressen gevonden",
  search_email_filter_all: "Alles",
  search_email_filter_content: "Inhoud",
  search_email_filter_addresses: "Adressen",
  search_email_filter_attachments: "Bijlagen",
  search_email_filter_has_attachments: "Met bijlagen",
  search_email_filter_unread: "Ongelezen",
  search_email_combo_placeholder: "In e-mails van (optioneel)…",
  search_email_combo_content_placeholder: "Zoek in die e-mails…",
  search_email_combo_hint: "Zoeken in e-mails van",
  search_email_combo_containing: "met inhoud",
  search_describe: "Beschrijf waar je naar zoekt…",
  search_describe_examples_with_email: "bijv. e-mails van ml@bl2020.com over wachtwoord · berichten van Martin over factuur · gebruiker Martin Langen",
  search_intent_understood: "Zoeken",
  search_intent_emails: "E-mails",
  search_intent_messages: "Berichten",
  search_intent_user: "Gebruiker",
  search_submit: "Zoeken",
  email_subject_label: "Onderwerp",
  email_body_label: "Inhoud",
  email_address_received: "Ontvangen",
  email_address_sent: "Verzonden",
  unnamed_group: "Naamloze groep",
  unnamed_room: "Naamloos project",
  all_members: "Alles",
  room_label: "Project:",
  subject_label: "Onderwerp:",
  no_members: "Geen leden",
  // Loading states for room creation
  creating_structure: "Uw structuur aanmaken",
  opening_chat: "Chat openen",
  please_wait: "Even geduld a.u.b...",
  // ToDo page translations
  loading_todo: "ToDo laden...",
  task_updated: "Taak bijgewerkt",
  error_updating_task: "Fout bij het bijwerken van taak",
  task_deleted: "Taak verwijderd",
  error_deleting_task: "Fout bij het verwijderen van taak",
  delete_task_confirm: "Weet u zeker dat u deze taak wilt verwijderen?",
  description_label: "Beschrijving",
  description_placeholder: "Voer beschrijving in...",
  date_time_label: "Datum en tijd",
  save_hint: "Ctrl+Enter om op te slaan, Esc om te annuleren",
  edit_label: "Bewerken",
  delete_label: "Verwijderen",
  todo_list_title: "Taken",
  tasks_count: "taken",
  search_placeholder_todo: "Zoeken...",
  select_task_to_open_chat: "Selecteer een taak om de chat te openen",
  today: "Vandaag",
  yesterday: "Gisteren",
  time_suffix: "", // Empty for Dutch (24h format doesn't need suffix)
  from_chat: "Brontaak",
  assigned_to: "Toegewezen aan",
  assign_users: "Gebruikers toewijzen",
  no_users_assigned: "Geen gebruikers toegewezen",
  assign: "Toewijzen",
  assign_to: "Toewijzen aan...",
  navigate_to_chat: "Navigeer naar chat",
  navigate_to_email: "Ga naar e-mail",
  show_original_message: "Bron tonen",
  hide_original_message: "Bron verbergen",
  status_pending: "In behandeling",
  status_in_progress: "Bezig",
  status_completed: "Voltooid",
  status_confirmed: "Bevestigd",
  show: "Tonen",
  close: "Sluiten",
  log_todo_created: "ToDo aangemaakt",
  log_todo_confirmed: "ToDo bevestigd",
  log_todo_deleted: "ToDo verwijderd",
  log_todo_updated: "ToDo bijgewerkt",
  log_description_updated: "Beschrijving bijgewerkt",
  log_deadline_updated: "Deadline bijgewerkt",
  log_assigned_to: "Toegewezen aan {name}",
  log_unassigned_from: "Verwijderd van {name}",
  log_assignment_added: "Toewijzing toegevoegd: {name}",
  log_assignment_removed: "Toewijzing verwijderd: {name}",
  log_status_updated: "Status gewijzigd van {from} naar {to}",
  log_status_changed: "Status gewijzigd",
  log_status_changed_to: "Status gewijzigd naar {status}",
  log_changed_status_to: "Status gewijzigd naar:",
  log_for_user: "voor gebruiker:",
  log_user_updated_status: "Gebruiker heeft ToDo-status bijgewerkt",
  log_changed_date_to: "Datum gewijzigd naar:",
  log_changed_description_to: "Beschrijving gewijzigd naar:",
  log_moved_to: "Verplaatst naar {status}",
  todo_status_updated_from: "van",
  todo_status_updated_to: "naar",
  filter_pending: "In afwachting",
  filter_confirmed: "Bevestigd",
  my_list: "Mijn dag",
  todo_adjust_list: "Lijst bewerken",
  apply: "Toepassen",
  filter_assigned_to_me: "Mijn taken",
  filter_assigned_by_me: "Gedelegeerd",
  todo_project_label: "Project:",
  assigned_users: "Toegewezen gebruikers:",
  todo_chat_label: "Chat:",
  history: "Geschiedenis",
  todo_assigned_by: "Toegewezen door:",
  todo_assigned_push: "ToDo toegewezen:",
  todo_assigned_push_empty: "Er is een nieuwe ToDo aan je toegewezen.",
  search_groups: "Groepen",
  search_chat_groups: "Chatgroepen",
  search_project_room: "Project",
  search_messages_tab: "Berichten",
  searching_groups: "Groepen zoeken...",
  searching_rooms: "Projecten zoeken...",
  no_groups_found: "Geen groepen gevonden",
  no_rooms_found: "Geen projecten gevonden",
  // ToDo filter translations
  todo_filters: "Filters",
  todo_filter_by_project: "Filteren op project",
  todo_status: "Status",
  todo_assignment: "Toewijzing",
  todo_filter_by_user: "Filteren op toegewezen persoon",
  todo_active_filters: "Actieve filters:",
  todo_progress: "Voortgang",
  todo_my_list_empty: "Je dag is leeg",
  todo_my_list_empty_hint: "Klik op de knop hierboven om taken toe te voegen",
  create_poll: "Peiling",
  poll_question_label: "VRAAG",
  poll_question_placeholder: "Stel een vraag",
  poll_options_label: "OPTIES",
  poll_option: "Optie",
  poll_add_option: "Optie toevoegen",
  poll_allow_multiple: "Meerdere antwoorden toestaan",
  poll_multiple_allowed: "Selecteer een of meer opties",
  poll_select_option: "Selecteer een optie",
  poll_view_votes: "Bekijk stemmen",
  poll_vote_singular: "stem",
  poll_vote_plural: "stemmen",
  poll_votes: "Peilingstemmen",
  poll_no_votes_yet: "Nog geen stemmen",
  transcript_step_processing: "Transcriptie bezig...",
  ai_transcript_tab: "AI-Transcriptie",
  ai_transcript_info: "Alleen beschikbaar voor spraakberichten aangemaakt na 09.03.2026.",
  transcript_more: "...meer",
  transcript_less: "...minder",
  ki_transcript_voice_message: "KI-Transcript van spraakbericht",
  ki_image_analysis: "AI-ondersteunde beeldanalyse",
  type_message: "Typ een bericht",
  email_tab_messages: "Berichten",
  email_tab_email: "E-mail",
  email_tab_messages_and_email: "Messages & E-Mail",
  email_tab_email_details: "E-Mail Details",
  email_accounts: "E-mailaccounts",
  email_connect_gmail: "Gmail verbinden",
  email_connect_outlook: "Outlook verbinden",
  email_no_accounts: "Geen e-mailaccounts verbonden",
  email_no_accounts_hint: "Verbind een e-mailaccount in je profielinstellingen",
  email_no_messages: "Geen e-mails",
  email_from: "Van",
  email_to: "Aan",
  email_subject: "Onderwerp",
  email_disconnect: "Verbreek verbinding",
  email_disconnect_confirm: "Weet u zeker dat u dit e-mailaccount wilt verbreken? Alle gesynchroniseerde e-mails worden verwijderd.",
  email_account_disconnected: "E-mailaccount succesvol losgekoppeld",
  email_account_disconnect_failed: "Kan e-mailaccount niet loskoppelen",
  email_connecting: "Verbinden...",
  email_account_connected: "Account succesvol verbonden",
  email_connected_accounts: "Verbonden accounts",
  email_sync_info: "Bij het verbinden van een e-mailaccount worden standaard de e-mails van de afgelopen maand gesynchroniseerd. U kunt de synchronisatieperiode hieronder uitbreiden.",
  email_sync_3_months: "Laatste 3 maanden synchroniseren",
  email_sync_6_months: "Laatste 6 maanden synchroniseren",
  email_syncing: "Synchroniseren...",
  email_sync_already_done: "{months} maanden al gesynchroniseerd",
  email_sync_more: "Meer maanden synchroniseren",
  email_sync_all_done: "Alle maanden gesynchroniseerd",
  email_syncing_account: "Account wordt gesynchroniseerd, dit kan enkele minuten duren…",
  email_signature: "Signature",
  email_signature_placeholder: "Enter your email signature...",
  email_signature_save: "Save",
  email_signature_saved: "Saved",
  email_add_account: "Account toevoegen",
  email_folder_inbox: "Postvak IN",
  email_folder_spam: "Spam",
  email_folder_drafts: "Concepten",
  email_folder_sent: "Verzonden items",
  email_folder_deleted: "Verwijderde items",
  email_folder_archive: "Archief",
  email_folder_outbox: "Postvak UIT",
  email_custom_folders: "Mappen",
  email_create_folder: "Nieuwe map",
  email_delete_folder: "Map verwijderen",
  email_folder_name_placeholder: "Mapnaam",
  email_folder_created: "Map aangemaakt",
  email_folder_deleted: "Map verwijderd",
  email_move_to: "Verplaatsen naar",
  email_moved_to_folder: "Verplaatst naar map",
  email_move_to_inbox: "Verplaatsen naar Postvak IN",
  email_confirm_delete_folder: "Weet u zeker dat u deze map wilt verwijderen?",
  email_refresh: "Vernieuwen",
  email_go_to_settings: "Ga naar instellingen",
  email_date: "Datum",
  email_reply: "Beantwoorden",
  email_forward: "Doorsturen",
  email_copy_text: "Tekst kopiëren",
  email_text_copied: "Gekopieerd!",
  email_text_copy_failed: "De tekst kon niet worden gekopieerd.",
  email_delete: "Verwijderen",
  email_not_spam: "Geen spam",
  email_not_spam_success: "E-mail verplaatst naar inbox.",
  email_not_spam_failed: "Verplaatsen naar inbox mislukt.",
  email_delete_confirm: "Weet u zeker dat u deze e-mail wilt verwijderen?",
  email_delete_from_folder: "Weet u zeker dat u uit {folder} wilt verwijderen?",
  email_delete_permanent_from_folder:
    "Weet u zeker dat u permanent uit {folder} wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.",
  email_save_draft_confirm: "Wilt u deze e-mail als concept opslaan?",
  email_save_draft: "Concept opslaan",
  email_discard: "Verwijderen",
  email_back_to_compose: "Terug naar opstellen",
  email_draft_saved: "Concept opgeslagen.",
  email_draft_save_failed: "Concept opslaan mislukt.",
  email_loading: "E-mails laden...",
  email_imap_title: "IMAP",
  email_imap_hint: "Verbind elk e-mailaccount via IMAP.",
  email_imap_user: "E-mail",
  email_imap_password: "Wachtwoord",
  email_imap_connect_btn: "IMAP-account verbinden",
  email_imap_required: "Vul e-mail en wachtwoord in.",
  email_imap_failed: "IMAP-verbinding mislukt.",
  email_imap_manual_toggle: "Handmatige serverinstellingen",
  email_imap_host: "IMAP-server (bijv. imap.ionos.de)",
  email_imap_port: "Poort",
  email_imap_incoming: "Inkomende post (IMAP)",
  email_smtp_outgoing: "Uitgaande post (SMTP)",
  email_smtp_host: "SMTP-server (bijv. smtp.ionos.de)",
  email_smtp_port: "Poort",
  email_send_btn: "Verzenden",
  email_sent: "E-mail verzonden.",
  email_send_failed: "E-mail verzenden mislukt.",
  email_compose_to_required: "Ontvanger (Aan) is verplicht.",
  email_compose_body_required: "Voer een onderwerp of berichttekst in.",
  email_original_message: "Origineel bericht",
  email_forwarded_message: "Doorgestuurd bericht",
  email_archived: "Archived",
  email_mark_spam: "Mark as spam",
  email_marked_spam: "Marked as spam",
  email_group_today: "Today",
  email_group_yesterday: "Yesterday",
  email_group_this_week: "This week",
  email_group_earlier: "Earlier",
  email_search: "Search",
  email_search_placeholder: "Search mail",
  email_no_results: "No matching messages",
  email_clear_search: "Clear search",
  email_star: "Star",
  email_unstar: "Unstar",
  email_starred: "Starred",
  email_folder_starred: "Starred",
  email_select: "Selecteren",
  email_attachment_singular: "Bijlage",
  email_attachment_plural: "Bijlagen",
  email_back: "Terug",
  email_download: "Downloaden",
  email_close: "Sluiten",
  email_preview: "Voorbeeld",
  email_preview_not_available: "Voorbeeld niet beschikbaar",
  email_preview_failed: "Voorbeeld niet beschikbaar",
  select_attachments: "Bijlagen selecteren",
  email_loading_preview: "Voorbeeld laden...",
  email_mark_unread_failed: "e-mail(s) konden niet als ongelezen worden gemarkeerd.",
  email_delete_failed: "e-mail(s) konden niet worden verwijderd.",
  filter_all: "Alle",
  filter_email: "E-Mail",
  filter_kjuup_messages: "Kjuup",
  filter_direct_messages: "Directe berichten",
  my_notes: "My Space",
  filter_internal_groups: "Interne groepchats",
  filter_external_groups: "Externe groepchats",
  filter_group_chats: "Groepchats",
  filter_groups_internal: "Intern",
  filter_groups_external: "Extern",
  filter_unread_only: "Alleen ongelezen",
  room_daily_briefing_info: "Indien ingeschakeld, wordt elke 24 uur op het tijdstip uit je persoonlijke instellingen een rapport voor dit project gegenereerd — maar alleen als er in die periode activiteit was.",
  email_select_all: "Alles selecteren",
  email_deselect_all: "Alles deselecteren",
  email_reply_all: "Allen beantwoorden",
  email_reply_placeholder: "Typ uw antwoord...",
  email_forward_placeholder: "Voeg een bericht toe...",
  email_edit_draft: "Concept bewerken",
  email_attach: "Bijlagen",
  email_attachment_from_original: "Van origineel bericht",
  email_remove: "Verwijderen",
  email_drop_files: "Sleep bestanden om bij te voegen",
  email_loading_attachments: "Bijlagen laden...",
  email_archive: "Archiveren",
  mark_unread: "Markeren als ongelezen",
  mark_read: "Markeren als gelezen",
  email_all_accounts: "Alle accounts",
  email_error: "Fout",
  email_delete_email_failed: "E-mail kon niet worden verwijderd.",
  enter_url: "Voer URL in",

  // ─── Kjuup subscription ───────────────────────────────────────────
  kjuup_io: 'Kjuup.io',
  kjuup_io_manage_subscription: 'Manage your subscription',
  kjuup_io_subscribe_now: 'Nu abonneren',
  kjuup_io_hero_subtitle: 'Upgrade to unlock premium features and get more out of every project.',
  kjuup_io_trial_badge: '1 MAAND GRATIS PROBEREN',
  kjuup_io_trial_title: 'Unlock Kjuup.io Premium',
  kjuup_io_trial_subtitle: 'Connect your email, receive AI-powered smart replies and synchronize your tasks with your calendar.',
  kjuup_io_trial_no_payment: 'No payment today.',
  kjuup_io_trial_trust: 'Vandaag geen betaling. Er worden geen creditcardgegevens gevraagd voordat je betaalde abonnement start.',
  kjuup_io_after_trial_monthly: 'After trial: {price}/month',
  kjuup_io_after_trial_yearly: 'After trial: {price}/year',
  kjuup_io_price_per_month: '{price}/month',
  kjuup_io_price_per_year: '{price}/year',
  kjuup_io_start_free_trial: 'Start free now � no risk',
  kjuup_io_trial_footnote: 'No payment today. Then {price}. Cancel anytime.',
  kjuup_io_feature_email: 'Beheer alle e-mailaccounts direct in Kjuup',
  kjuup_io_feature_assign: 'Automatically assign emails and attachments to projects',
  kjuup_io_feature_ai: 'AI schrijft antwoorden – jij bevestigt alleen',
  kjuup_io_feature_tasks: 'Taken & agenda altijd automatisch up-to-date',
  kjuup_io_choose_plan: 'Kies je plan',
  kjuup_io_plan_monthly: 'Maandelijks',
  kjuup_io_plan_yearly: 'Jaarlijks',
  kjuup_io_plan_monthly_desc: 'Billed monthly · cancel anytime',
  kjuup_io_plan_yearly_desc: 'Save {pct}% with annual booking',
  kjuup_io_save_badge: 'SAVE {pct}%',
  kjuup_io_per_month_annual: '{price} / month · Save {pct}% with annual booking',
  kjuup_io_subscribe: 'Subscribe',
  kjuup_io_secured_stripe: 'Beveiligd door Stripe · altijd opzegbaar',
  kjuup_io_your_subscription: 'YOUR SUBSCRIPTION',
  kjuup_io_status_active: 'ACTIVE',
  kjuup_io_status_cancels_soon: 'CANCELS SOON',
  kjuup_io_status_switch_scheduled: 'SWITCH SCHEDULED',
  kjuup_io_label_plan: 'Plan',
  kjuup_io_label_price: 'Price',
  kjuup_io_label_status: 'Status',
  kjuup_io_label_renews: 'Renews on',
  kjuup_io_label_access_until: 'Access until',
  kjuup_io_switching_to: 'Switching to {plan} on {date}',
  kjuup_io_cancel_pending_note: 'Your subscription is set to cancel and won\'t renew. You keep access until the date above.',
  kjuup_io_resume: 'Resume subscription',
  kjuup_io_switch_to_plan: 'Switch to {plan} plan',
  kjuup_io_undo_switch: 'Undo scheduled change',
  kjuup_io_cancel_subscription: 'Cancel subscription',
  kjuup_io_switch_modal_title: 'Switch to {plan} plan?',
  kjuup_io_billed_yearly: 'Billed yearly',
  kjuup_io_billed_monthly: 'Billed monthly',
  kjuup_io_switch_modal_note: 'Starts on {date}, when your current {plan} plan ends. No charge today — you keep your current plan until then.',
  kjuup_io_confirm_switch: 'Confirm switch',
  kjuup_io_not_now: 'Not now',
  kjuup_io_cancel_modal_title: 'Cancel subscription?',
  kjuup_io_cancel_modal_note: 'You\'ll keep access to Kjuup.io until the end of your current billing period. After that it won\'t renew.',
  kjuup_io_cancel_modal_note_with_date: 'You\'ll keep access to Kjuup.io until the end of your current billing period ({date}). After that it won\'t renew.',
  kjuup_io_cancel_plan: 'Cancel plan',
  kjuup_io_keep_subscription: 'Keep my subscription',
  kjuup_io_toast_payment_failed: 'Payment failed',
  kjuup_io_toast_activating: 'Betaling ontvangen. Abonnement activeren…',
  kjuup_io_toast_activating_soon: 'Betaling ontvangen. Je abonnement wordt binnenkort geactiveerd.',
  kjuup_io_toast_cancel_period: 'Your subscription will cancel at the end of the period',
  kjuup_io_toast_cancel_fail: 'Unable to cancel subscription',
  kjuup_io_toast_switch_scheduled: 'You\'ll move to the {plan} plan when your current period ends',
  kjuup_io_toast_switch_fail: 'Unable to switch plan',
  kjuup_io_toast_resumed: 'Your subscription will keep renewing',
  kjuup_io_toast_resume_fail: 'Unable to resume subscription',
  kjuup_io_toast_undo: 'Scheduled plan change canceled',
  kjuup_io_toast_undo_fail: 'Unable to cancel the scheduled change',
  kjuup_io_email_locked_body: 'Email is part of Kjuup.io. Activate a plan to use the Email tab.',
  kjuup_io_connect_email: 'Connect email with Kjuup.io',
  kjuup_io_activate_to_connect_email: 'Activate Kjuup.io to connect email accounts',

  kjuup_io_trial_no_card: 'No credit card details are requested before your paid subscription starts.',
  kjuup_io_status_trialing: 'TRIAL',
  kjuup_io_trial_days_left: '{days} days left in your free trial',
  kjuup_io_trial_left_hours: 'Nog {count} uur',
  kjuup_io_trial_left_hour: 'Nog 1 uur',
  kjuup_io_trial_left_minutes: 'Nog {count} minuten',
  kjuup_io_trial_left_minute: 'Nog 1 minuut',
  kjuup_io_trial_left_seconds: 'Nog {count} seconden',
  kjuup_io_trial_left_second: 'Nog 1 seconde',
  kjuup_io_trial_ending_now: 'Je proefperiode loopt af…',
  kjuup_io_request_timeout: 'De verbinding is verlopen. Probeer het opnieuw.',
  kjuup_io_info_days_free: '{days} dagen volledig gratis – je abonnement start pas na de proefperiode.',
  kjuup_io_discount_total: 'Je korting: {percent}%',
  kjuup_io_discount_company: '{company}: {percent}%',
  kjuup_io_discount_personal: 'Persoonlijk: {percent}%',
  kjuup_io_trial_ends_tomorrow: 'Your free trial ends tomorrow',
  kjuup_io_trial_ends_today: 'Your free trial ends today',
  kjuup_io_banner_dismiss: 'Sluiten',
  kjuup_io_billing_after_trial: 'You\'ll be charged after your trial ends on {date}.',
  kjuup_io_trial_ended_title: 'Uw gratis proefperiode is afgelopen',
  kjuup_io_trial_ended_body: 'Neem een abonnement op Kjuup.io om e-mail en andere premiumfuncties te blijven gebruiken.',
  kjuup_io_subscribe_to_continue: 'Subscribe now to continue',
  kjuup_io_trial_active_title: 'You\'re on a free trial',
  kjuup_io_trial_active_subtitle: 'Choose a plan and subscribe — billing starts when your trial ends.',
  kjuup_io_toast_trial_started: 'Uw gratis proefperiode is begonnen',
  kjuup_io_toast_trial_fail: 'Gratis proefperiode kon niet worden gestart',
  kjuup_io_trial_try_month: 'Try Kjuup.io free for one month.',
  kjuup_io_per_month: 'per month',
  kjuup_io_price_month_line: '{price} / maand',
  kjuup_io_save_amount_year: 'Bespaar {price} per jaar',
  kjuup_io_billed_annually_amount: '{price} jaarlijks gefactureerd',
  kjuup_io_save_yearly: 'Save {pct}% with yearly billing.',
  kjuup_io_savings_pct: '{pct}% savings',
  kjuup_io_features_title: 'Wat je krijgt:',
  kjuup_io_info_one_month_free: 'One month free',
  kjuup_io_info_plan_after_trial: 'Your selected subscription starts after the trial.',
  kjuup_io_info_cancel_trial: 'Cancel anytime during the trial.',
  kjuup_io_info_no_card: 'Geen creditcard nodig – start meteen, zonder betalingsgegevens.',
  kjuup_io_info_cancel_anytime: 'Altijd opzegbaar – geen verplichting, geen risico.',
  kjuup_io_cta_plan_begins: 'Your selected plan begins after the free trial.',
  kjuup_io_billing_period_aria: 'Factuurperiode',
  kjuup_io_subscription_info_title: 'Subscription information',
  kjuup_io_first_payment_on: 'First payment on {date}.',
  kjuup_io_renews_on: 'Renews on {date}.',
  kjuup_io_toast_card_saved: 'Betaalmethode opgeslagen. De afschrijving volgt aan het einde van de proefperiode.',
  calendar_sync_info: 'Synchroniseer automatisch alle Kjuup ToDo\'s met je agenda.',
  calendar_no_accounts: 'Nog geen kalender verbonden.',
  article_new_badge: 'NIEUW',
  article_new_posts: '{0} nieuwe berichten',
  documents: 'Documenten',
  add_documents: 'Documenten toevoegen',
  no_preview_available: 'Geen voorbeeld beschikbaar',
  no_preview_hint: 'Dit bestandstype kan niet worden voorvertoond, maar wordt wel verzonden.',
  max_documents_reached: 'Je kunt maximaal 10 documenten tegelijk toevoegen.',
  open_file: 'Bestand openen',
  twofa_title: 'Tweestapsverificatie',
  twofa_method_totp: 'Authenticator-app',
  twofa_method_sms: 'Sms',
  twofa_method_email: 'E-mail',
  twofa_enter_app: 'Voer de 6-cijferige code uit je authenticator-app in.',
  twofa_enter_sms: 'Voer de 6-cijferige code in die we per sms hebben gestuurd.',
  twofa_enter_email: 'Voer de 6-cijferige code in die we naar je e-mail hebben gestuurd.',
  twofa_resend: 'Code opnieuw versturen',
  twofa_try_another: 'Andere methode proberen',
  twofa_remember_device: 'Op dit apparaat 30 dagen niet meer vragen',
  twofa_sent: 'We hebben een code gestuurd.',
  twofa_invalid_code: 'Die code is onjuist. Probeer het opnieuw.',
  twofa_something_wrong: 'Er ging iets mis. Probeer het opnieuw.',
  twofa_method_unavailable: 'Die methode is niet beschikbaar.',
  twofa_on_desc: 'Tweestapsverificatie staat aan. Je hebt bij elke login een code nodig.',
  twofa_off_desc: 'Voeg na je wachtwoord een tweede stap toe. Authenticator-apps zijn het veiligst.',
  twofa_methods: 'Methoden',
  twofa_on: 'Aan',
  twofa_add: 'Toevoegen',
  twofa_default_method: 'Standaardmethode',
  twofa_default: 'Standaard',
  twofa_turn_off: 'Uitschakelen',
  twofa_disable_hint: 'Voer je wachtwoord en een actuele code in om tweestapsverificatie uit te schakelen.',
  twofa_disable_need: 'Voer je wachtwoord en een verificatiecode in.',
  twofa_code_placeholder: '6-cijferige code of back-upcode',
  twofa_send_code: 'Code versturen',
  twofa_primary_updated: 'Standaardmethode bijgewerkt.',
  twofa_disabled: 'Tweestapsverificatie staat nu uit.',
  twofa_enabled: 'Tweestapsverificatie staat nu aan.',
  twofa_totp_help: 'Scan deze QR-code met Google Authenticator, Authy of 1Password. Je kunt de sleutel ook handmatig invoeren.',
  twofa_secret_copied: 'Sleutel gekopieerd',
  twofa_sms_help: 'Voer je nummer in internationaal formaat in. We sturen een 6-cijferige code per sms.',
  twofa_email_help: 'We sturen een 6-cijferige code naar het e-mailadres van je account.',
  twofa_backup_title: 'Back-upcodes',
  twofa_backup_help: 'Bewaar deze eenmalige codes op een veilige plek. Elke code werkt één keer als je je telefoon kwijt bent.',
  twofa_copy_codes: 'Codes kopiëren',
  twofa_codes_copied: 'Back-upcodes gekopieerd',
  twofa_regenerate: 'Nieuwe back-upcodes ophalen',
  twofa_regenerate_hint: 'Dit vervangt ongebruikte back-upcodes. Voer je wachtwoord en een huidige code in.',
  twofa_backup_remaining: '{n} ongebruikte back-upcodes over',
  twofa_new_codes: 'Nieuwe back-upcodes',
  twofa_sms_unavailable: 'Sms-codes zijn nog niet beschikbaar.',
  todoist_sync_title: "Todoist",
  todoist_sync_info: "Toegewezen Kjuup-taken worden gekopieerd naar een project Kjuup in je Todoist. Wijzigingen in Todoist worden niet teruggekopieerd.",
  todoist_connect: "Todoist koppelen",
  todoist_connected: "Todoist gekoppeld",
  todoist_connect_failed: "Todoist koppelen mislukt",
  todoist_disconnect: "Ontkoppelen",
  todoist_disconnected: "Todoist ontkoppeld",
  todoist_disconnect_confirm: "Todoist ontkoppelen? Taken die al in Todoist staan blijven staan. Synchronisatie stopt.",
  todoist_sync_now: "Nu synchroniseren",
  todoist_syncing: "Synchroniseren…",
  todoist_sync_done: "Synchronisatie voltooid",
  todoist_sync_failed: "Synchronisatie mislukt",
  todoist_auth_error: "Koppel Todoist opnieuw om te blijven synchroniseren.",
  todoist_last_sync: "Laatste synchronisatie",
  todoist_not_connected: "Todoist is niet gekoppeld",
  todoist_auth_url_failed: "De Todoist-autorisatiepagina kon niet worden geopend.",
  recommend_text: "Sluit je aan bij Kjuup om verbonden te blijven en je communicatie georganiseerd te houden. Breng je kanalen samen, houd berichten in de juiste projecten en begin elke ochtend met een samenvatting en je taken – alles gesynchroniseerd met de apps die je al gebruikt. Begin gratis:",
  pro_auth_signin_title: 'Welkom terug',
  pro_auth_signin_sub: 'Meld u aan met uw zakelijke e-mail.',
  pro_auth_email_or_username: 'E-mail of gebruikersnaam',
  pro_auth_email_placeholder: 'naam@bedrijf.nl',
  pro_auth_forgot_password: 'Wachtwoord vergeten?',
  pro_auth_create_account: 'Account aanmaken',
  pro_auth_show_password: 'Wachtwoord tonen',
  pro_auth_hide_password: 'Wachtwoord verbergen',
  pro_auth_register_sub: 'We sturen u een link om uw e-mail te bevestigen.',
  pro_auth_register_plus_sub: 'Kies een gebruikersnaam en een wachtwoord. Daarna stelt u uw beveiligingspincode in.',
  pro_auth_check_credentials: 'Controleer uw e-mail en wachtwoord',
  pro_news_export_pdf: 'Exporteren als PDF',
  pro_news_pdf_failed: 'De PDF kon niet worden aangemaakt.',
  pro_news_pdf_attachments: 'Bijlagen',
  pro_news_pdf_video: 'Video',
  pro_auth_forgot_sub: 'Voer uw e-mail in en we sturen u een link om uw wachtwoord te resetten.',
  pro_auth_send_link: 'Resetlink verzenden',
  pro_auth_plus_reset: 'Resetten met pincode',
  pro_auth_show_pin: 'Pincode tonen',
  pro_auth_hide_pin: 'Pincode verbergen',
  v2_auth_plus_only: 'Alleen Kjuup+',
  room_action_media: "Bestanden",
  room_tab_overview: "Overzicht",
  room_tab_history: "Geschiedenis",
  chat_info_media: "Bestanden",
  messages: "berichten",
  pro_todo_project_required: "Kies een project",
  pro_todo_choose_project: "Voor welk project is deze taak?",
  cockpit_report_delete_confirm: "Dit dagrapport verwijderen?",
  cockpit_report_deleted: "Dagrapport verwijderd",
  cockpit_tab_company: "Bedrijf",
  cockpit_bookmarked_priorities: "Gemarkeerde taken",
  cockpit_load_error: "De cockpit kon niet worden geladen.",
  cockpit_retry: "Opnieuw proberen",
  cockpit_yesterday: "Gisteren",
  cockpit_greeting_morning: "Goedemorgen",
  cockpit_greeting_day: "Goedemiddag",
  cockpit_greeting_evening: "Goedenavond",
  cockpit_assistant_q_open: "Wat staat er vandaag open?",
  cockpit_assistant_q_summarize: "Vat de chat {{room}} samen",
  cockpit_assistant_q_overdue: "Welke taken zijn te laat?",
  cockpit_assistant_new: "{{n}} nieuw",
  cockpit_assistant_important: "{{n}} belangrijk",
  cockpit_assistant_title: "Kjuup-assistent",
  cockpit_assistant_hint: "Tik en stel een vraag",
  room_overview_priority_no_detail: "Het rapport geeft geen verdere details over deze prioriteit.",
  room_overview_priority_from: "Bron: {{name}}",
  room_overview_priority_open_task: "Taak openen",
  cockpit_priority_position: "{{index}} van {{total}} prioriteiten",
  room_overview_today_title: "Vandaag belangrijk",
  room_overview_all_tasks: "Alle",
  room_overview_tasks_empty: "Geen openstaande deadlines of taken",
  room_overview_appointments_empty: "Geen komende afspraken",
  room_overview_no_priorities: "Geen openstaande prioriteiten in het laatste rapport.",
  cockpit_report_top5: "Top 5 prioriteiten",
  cockpit_report_todo_created: "Taak aangemaakt",
  cockpit_report_source_missing: "Het oorspronkelijke bericht is niet gevonden.",
  delete_bookmarked_priority_confirm: "Weet u zeker dat u deze gemarkeerde taak wilt verwijderen?",
  cockpit_report_create_todo: "Taak aanmaken",
  cockpit_priorities_deleting: "Verwijderen …",
  cockpit_priorities_select: "Meerdere verwijderen",
  cockpit_report_none: "Geen items.",
  cockpit_priorities_delete_confirm: "Weet u zeker dat u {count} gemarkeerde taken wilt verwijderen?",
  cockpit_priorities_delete_failed: "{count} taken konden niet worden verwijderd",
  cockpit_priorities_deleted: "{count} taken verwijderd",
  cockpit_priorities_selected: "{count} geselecteerd",
  cockpit_channel_connected: "Verbonden",
  cockpit_channel_not_connected: "Niet verbonden",
  cockpit_channel_connect: "Verbinden",
  cockpit_channel_chat: "Kjuup-chat",
  cockpit_channel_active: "Actief",
  cockpit_channel_hidden: "Verborgen",
  cockpit_channel_enable: "Inschakelen",
  cockpit_channel_email: "E-mail",
  cockpit_channel_check: "Verbinding controleren",
  cockpit_channel_fix: "Controleren",
  cockpit_channel_forward: "Doorstuuradres",
  cockpit_channel_not_set_up: "Niet ingesteld",
  cockpit_channel_set_up: "Instellen",
  cockpit_channel_teams: "Microsoft Teams",
  cockpit_channel_broken: "Verbinding verbroken",
  cockpit_channel_importing: "Importeren bezig",
  cockpit_channel_removing: "Verbinding wordt verbroken",
  cockpit_channel_reconnect: "Opnieuw verbinden",
  cockpit_channels_title: "Kanalen",
  cockpit_company_role_super_admin: "Bedrijfsbeheerder",
  cockpit_company_role_dept_admin: "Afdelingsbeheerder",
  cockpit_company_role_member: "Medewerker",
  cockpit_company_none: "Geen Kjuup+-bedrijf gevonden",
  cockpit_company_eyebrow: "Bedrijf",
  cockpit_company_inactive: "inactief",
  cockpit_company_settings: "Bedrijfsinstellingen",
  cockpit_company_employees: "Medewerkers",
  cockpit_company_internal_rooms: "Interne projecten",
  cockpit_report_all_projects: "Alle projecten",
  cockpit_report_progress_emails: "E-mails worden geanalyseerd",
  cockpit_report_progress_chats: "Chatberichten worden geanalyseerd",
  cockpit_report_progress_documents: "Bijlagen en documenten worden geanalyseerd",
  cockpit_report_progress_tasks: "Taken worden geanalyseerd",
  cockpit_report_progress_summarizing: "Inhoud wordt geanalyseerd",
  cockpit_report_progress_reading: "Eerder geanalyseerde inhoud wordt overgenomen",
  cockpit_report_progress_collecting: "E-mails, chats en taken uit uw projecten worden verzameld",
  cockpit_report_progress_priorities: "Prioriteiten, deadlines en beslissingen worden samengesteld",
  cockpit_report_progress_queued: "Het rapport wordt voorbereid",
  cockpit_report_creating_title: "Uw dagrapport wordt opgesteld",
  cockpit_report_progress_count_one: "1 item geanalyseerd",
  cockpit_report_progress_count_many: "{{count}} items geanalyseerd",
  cockpit_report_progress_hint: "Dit duurt meestal een tot twee minuten – u kunt de cockpit intussen blijven gebruiken.",
  cockpit_report_time_hint: "Het dagrapport wordt elke dag om {{hour}}:00 uur opgesteld voor de vijf meest actieve projecten.",
  room_overview_priorities_title: "Actuele status en prioriteiten",
  room_overview_as_of: "Bijgewerkt: {{time}}",
  cockpit_report_delete: "Dagrapport verwijderen",
  email_tag_daily_briefing: "Dagrapport",
  cockpit_report_unread: "Nieuw",
  cockpit_report_clear_project: "Alle projecten tonen",
  cockpit_filter_project: "Project",
  cockpit_filter_all_projects: "Alle projecten",
  cockpit_report_recreate: "Dagrapport opnieuw aanmaken",
  cockpit_report_hide_previous: "Eerdere dagrapporten verbergen",
  cockpit_report_show_previous: "Eerdere dagrapporten tonen",
  cockpit_report_room_empty: "Nog geen dagrapport voor dit project",
  cockpit_report_empty: "Nog geen dagrapport",
  cockpit_report_room_empty_hint: "Maak een dagrapport alleen voor dit project.",
  cockpit_report_needs_mailbox: "Koppel een e-mailaccount, zodat Kjuup een dagrapport met automatische taken kan maken.",
  cockpit_report_create: "Dagrapport aanmaken",
  cockpit_email_connect: "E-mail koppelen",
  cockpit_email_none_title: "Nog geen e-mailaccount gekoppeld",
  cockpit_email_none_reports: "Koppel uw mailbox, zodat Kjuup binnenkomende e-mails aan uw projecten toewijst en er dagrapporten met taken van maakt.",
  cockpit_email_none_client: "Koppel Gmail, Outlook of IMAP om e-mails rechtstreeks in Kjuup.io te lezen, toe te wijzen en te beantwoorden.",
  cockpit_email_reports_title: "Huidige e-mailclient",
  cockpit_email_reports_text: "Geen inbox in Kjuup.io · {{rooms}} projecten met een dagrapport om {{hour}}:00 uur · binnenkomende e-mails worden aan uw projecten toegewezen.",
  cockpit_email_reports_rooms: "Projecten beheren",
  cockpit_email_settings: "E-mailinstellingen",
  cockpit_email_error_title: "Verbinding controleren",
  cockpit_email_client_title: "Ontvangst ingesteld",
  cockpit_email_accounts_n: "{{n}} account verbonden",
  cockpit_email_last_sync: "laatst opgehaald {{when}}",
  cockpit_email_report_at: "Dagrapport om {{hour}}:00 uur",
  cockpit_email_open_inbox: "Inbox openen",
  cockpit_email_eyebrow: "Kjuup-Email",
  cockpit_email_accounts_label: "Gekoppelde e-mailadressen",
  email_no_subject: "(Geen onderwerp)",
  cockpit_email_detail_loading: "E-mail wordt geladen …",
  cockpit_email_detail_failed: "De e-mail kon niet worden geladen.",
  cockpit_email_detail_empty: "Deze e-mail bevat geen tekst.",
  cockpit_personal_settings: "Persoonlijke instellingen",
  cockpit_companies: "Bedrijven",
  cockpit_title: "Cockpit",
  cockpit_back: "Terug naar overzicht",
  cockpit_day_overview: "Uw dag in één oogopslag",
  email_saved_to_project: "E-mail opgeslagen in project",
  email_classify_need_project: "Voer een projectnaam in",
  cockpit_email_deleted: "E-mail verwijderd",
  cockpit_email_sent_empty: "Nog geen verzonden e-mails.",
  cockpit_email_incoming_empty: "Nog geen binnenkomende e-mails.",
  cockpit_email_incoming_title: "E-mails",
  cockpit_email_incoming_sub: "Wijs binnenkomende en verzonden e-mails toe aan uw projecten. De toewijzing kunt u hier aanpassen.",
  cockpit_email_incoming_unassigned_n: "{{n}} niet toegewezen",
  cockpit_email_folder_inbox: "Postvak IN",
  cockpit_email_folder_sent: "Verzonden",
  cockpit_email_open: "E-mail openen",
  cockpit_email_incoming_suggested: "Suggestie: {{room}}",
  cockpit_email_incoming_apply: "Toepassen",
  cockpit_email_incoming_adjust: "Toewijzing aanpassen",
  cockpit_email_incoming_saving: "Opslaan …",
  cockpit_email_incoming_unassigned: "Niet toegewezen",
  cockpit_email_incoming_show_less: "Minder tonen",
  cockpit_email_incoming_show_all: "Alle {{n}} tonen",
  cockpit_io_settings: "Kjuup.io-instellingen",
  cockpit_io_settings_sub: "Abonnement en licenties, toewijzing van medewerkers, facturering en facturen.",
  products_coming_soon: "Binnenkort beschikbaar",
  cockpit_upsell_io_title: "Uw kantoor dat meedenkt",
  cockpit_upsell_io_text: "Koppel uw e-mailaccounts aan Kjuup. E-mails, bijlagen en berichten worden automatisch opgeslagen in het juiste project en kunnen optioneel op uw eigen server worden bewaard. Elke dag ontvangt u een samenvatting van alle projecten met de belangrijkste punten uit alle inhoud, en uw taken synchroniseren met uw agenda of takenapp.",
  cockpit_upsell_io_soon_title: "Nog niet te boeken",
  cockpit_upsell_io_soon_text: "Kjuup.io start binnenkort. Vraag nu informatie aan – wij laten het u weten zodra u Kjuup.io kunt boeken.",
  cockpit_upsell_io_planned_price: "Geplande prijs",
  cockpit_upsell_io_cta_request: "Informatie aanvragen",
  kjuup_plus_abo_per_year: "/ jaar",
  kjuup_plus_abo_per_month: "/ maand",
  kjuup_plus_abo_status_active: "Actief",
  kjuup_plus_abo_status_requested: "Opzegging aangevraagd",
  kjuup_plus_abo_status_past_due: "Betaling openstaand",
  kjuup_plus_abo_eyebrow: "Kjuup+ · Abonnement",
  kjuup_plus_abo_title: "Kjuup+-pakket",
  kjuup_plus_abo_seats_free_one: "Nog 1 plek vrij",
  kjuup_plus_abo_billing: "Betaalwijze",
  kjuup_plus_abo_yearly: "Jaarlijks",
  kjuup_plus_abo_monthly: "Maandelijks",
  kjuup_plus_abo_amount: "Bedrag",
  kjuup_plus_abo_ends: "Eindigt op",
  kjuup_plus_abo_renews: "Volgende verlenging",
  kjuup_plus_abo_next_invoice: "Volgende factuur",
  kjuup_plus_abo_intro: "Introductieprijs",
  kjuup_plus_abo_pending_tier: "Vanaf volgende verlenging",
  kjuup_plus_abo_manual: "Kjuup+ is voor uw bedrijf actief via een individuele overeenkomst.",
  kjuup_plus_abo_invoices: "Facturen",
  kjuup_plus_abo_invoice_paid: "Betaald",
  kjuup_plus_abo_invoice_view: "Bekijken",
  kjuup_plus_abo_invoices_less: "Minder tonen",
  kjuup_plus_abo_member_hint: "Facturering en opzegging worden beheerd door de bedrijfsbeheerders.",
  kjuup_plus_abo_withdraw: "Aanvraag intrekken",
  kjuup_plus_abo_cancel_note: "Reden (optioneel)",
  kjuup_plus_abo_cancel_send: "Opzegging aanvragen",
  kjuup_plus_abo_cancel: "Abonnement opzeggen",
  cockpit_upsell_plus_f1: "Communicatieactiviteiten van alle medewerkers beheren",
  cockpit_upsell_plus_f2: "Specifieke gebruikersgroepen binnen het bedrijf informeren",
  cockpit_upsell_plus_f3: "Interne groepschats opslaan",
  cockpit_upsell_plus_when_yearly: "bij jaarlijkse betaling",
  cockpit_upsell_plus_size_small: "1–50 medewerkers",
  cockpit_upsell_plus_size_large: "51–200 medewerkers",
  cockpit_upsell_plus_title: "Kjuup+ voor bedrijven",
  cockpit_upsell_plus_text: "Beheer medewerkers, schrijfrechten en bedrijfscommunicatie op één plek. Interne kanalen blijven bij uw team, externe kanalen verbinden u met projectpartners en u informeert specifieke groepen gericht. Naast Kjuup+ kunt u Kjuup.io-toegang voor medewerkersgroepen boeken. Kjuup+ en Kjuup.io zijn te combineren.",
  cockpit_upsell_plus_size: "Bedrijfsgrootte",
  cockpit_upsell_plus_billing: "Betaalwijze",
  cockpit_upsell_plus_per_company: "/ bedrijf · maand excl. btw",
  cockpit_upsell_plus_onboarding: "Kosten voor onboarding/implementatie zijn afhankelijk van de bedrijfsgrootte",
  cockpit_upsell_plus_larger: "Prijzen voor grotere bedrijven op aanvraag",
  cockpit_upsell_plus_cta: "Vrijblijvend aanvragen",
  cockpit_kpi_deadlines_tasks: "Deadlines en taken",
  cockpit_kpi_appointments: "Afspraken",
  cockpit_room_admin: "Project- en chatbeheer",
  cockpit_room_admin_sub: "Alle projecten van het bedrijf met leden, media en chats.",
  pro_todo_not_found: "Deze taak is niet meer beschikbaar.",
  cockpit_chip_overdue: "Te laat",
  cockpit_chip_today: "Vandaag",
  cockpit_calendar_week: "Wk {{week}}",
  cockpit_prev_week: "Vorige week",
  cockpit_next_week: "Volgende week",
  cockpit_chip_requested: "Opgevraagd",
  cockpit_todo_due: "Deadline {{when}}",
  cockpit_todo_at: "{{time}} uur",
  cockpit_todo_requested_from: "bij {{name}}",
  cockpit_todo_since: "sinds {{when}}",
  cockpit_todo_no_date: "Zonder datum",
  cockpit_todo_mark_done: "Markeren als voltooid",
  cockpit_my_tasks_title: "Mijn taken",
  cockpit_today_tasks_group: "Taken van vandaag",
  cockpit_assign_none: "Niemand toegewezen",
  no_project_found: "Geen project gevonden",
  cockpit_row_more_actions: "Meer acties",
  needs_date: "Afspraak toewijzen",
  cockpit_assign_proposal: "{{name}} herkend – toewijzen?",
  cockpit_assign_proposal_confirm: "Toewijzen",
  cockpit_assign_proposal_dismiss: "Negeren",
  cockpit_priority_date: "Datum",
  todo_calendar_add: "Aan agenda toevoegen",
  todo_calendar_remove: "Uit agenda verwijderen",
  cockpit_todo_change_project: "Project wijzigen",
  cockpit_todo_set_date: "Datum instellen",
  pro_todo_done_confirm: "Wilt u deze taak echt als voltooid markeren?",
  cockpit_task_delete_failed: "De taak kon niet worden verwijderd.",
  cockpit_setup_title: "Installatie voltooien",
  cockpit_setup_text: "Bepaal of u chats wilt gebruiken en of Kjuup.io als e-mailclient moet werken of alleen met projecten en dagrapporten.",
  cockpit_setup_cta: "Nu instellen",
  cockpit_group_tasks: "Deadlines en taken",
  cockpit_group_appointments: "Afspraken",
  cockpit_report_no_activity: "In dit project waren er de afgelopen 24 uur geen nieuwe berichten of e-mails.",
  cockpit_report_room_unavailable: "Dit project is niet beschikbaar.",
  cockpit_report_create_failed: "Het dagrapport kon niet worden aangemaakt.",
  cockpit_report_created: "Dagrapport aangemaakt",
  addon_enable_confirm: "Add-on inschakelen?",
  addon_enable: "Inschakelen",
  addon_enabled: "Add-on ingeschakeld",
  nav_email: "E-mail",
  nav_my_cockpit: "Mijn cockpit",
  nav_news: "Nieuws",
  nav_recommend: "Aanbevelen",
  pro_todo_status_done: "Voltooid",
  pro_todo_status_open: "Open",
  v2_todo_remove: "Verwijderen",
  pro_todo_search_people: "Personen zoeken",
  pro_todo_clear: "Wissen",
  pro_todo_assigned: "(toegewezen)",
  pro_todo_no_people: "Geen personen gevonden",
  pro_todo_search_rooms: "Projecten zoeken",
  pro_todo_no_rooms_match: "Geen projecten voor “{{q}}”",
  pro_todo_no_rooms: "Geen projecten gevonden",
  pro_todo_activity: "Activiteit",
  pro_todo_show_less: "Minder tonen",
  pro_todo_show_all: "Alles tonen ({{n}})",
  pro_todo_due: "Vervalt",
  pro_todo_room: "Project",
  pro_todo_select_room: "Project selecteren",
  pro_todo_status: "Status",
  pro_todo_more: "Meer",
  pro_todo_edit_title: "Taak bewerken",
  pro_todo_description: "Beschrijving",
  pro_todo_created_by: "Aangemaakt door",
  pro_todo_chat: "Chat",
  navigate_to_source: "Naar de bron gaan",
  todo_calendar_connect_title: "Geen agenda gekoppeld",
  todo_calendar_connect_body_web: "Koppel in de instellingen voor agendasynchronisatie een agenda om er taken aan toe te voegen.",
  todo_calendar_connect: "Koppelen",
  todo_calendar_removed: "Uit uw agenda verwijderd",
  todo_calendar_added_later: "Toegevoegd. Uw agenda was niet bereikbaar; Kjuup probeert het later opnieuw.",
  todo_calendar_added: "Aan uw agenda toegevoegd",
  todo_calendar_no_date: "Alleen een taak met een datum kan aan een agenda worden toegevoegd.",
  todo_calendar_failed: "Uw agenda kon niet worden bijgewerkt. Probeer het opnieuw.",
  todo_calendar_date_title: "Nog geen datum",
  todo_calendar_date_save: "Datum instellen en toevoegen",
  todo_calendar_date_body_web: "Deze gemarkeerde taak heeft nog geen datum. Stel er een in om de taak aan uw agenda toe te voegen.",
  kjuup_io_setup_saved: "Instelling opgeslagen",
  kjuup_io_setup_step: "Stap",
  kjuup_io_setup_chats_title: "Wilt u chats gebruiken?",
  kjuup_io_setup_email_title: "Waar wilt u uw e-mails lezen?",
  kjuup_io_setup_chats_sub: "Chats met collega's en projectpartners zijn optioneel. U kunt ze op elk moment in de cockpit tonen of verbergen.",
  kjuup_io_setup_email_sub: "Hier bepaalt u alleen of u een e-mailclient in Kjuup gebruikt of met uw huidige programma blijft werken, bijvoorbeeld Outlook of een ander. U kunt later wisselen.",
  kjuup_io_setup_chats_yes: "Ja, chats tonen",
  kjuup_io_setup_chats_yes_text: "Berichten bevat chats en e-mails. Projecten hebben groepschats voor alle betrokkenen.",
  kjuup_io_setup_chats_no: "Nee, zonder chats werken",
  kjuup_io_setup_chats_no_text: "Chats worden verborgen. „Berichten” wordt „E-mail”; projecten, taken en dagrapporten blijven.",
  kjuup_io_setup_email_client: "E-mailclient in Kjuup",
  kjuup_io_setup_email_client_text: "E-mails rechtstreeks in Kjuup lezen en beantwoorden.",
  kjuup_io_setup_email_reports: "Huidige e-mailclient",
  kjuup_io_setup_email_reports_text: "E-mails blijven lezen en beantwoorden in uw huidige programma, bijvoorbeeld Outlook of een ander.",
  kjuup_io_setup_skip: "Later",
  next: "Volgende",
  kjuup_io_setup_finish: "Installatie voltooien",
  today_label: "vandaag",
  tomorrow_label: "morgen",
  cockpit_todo_overdue: "te laat",
  cockpit_report_management_fazit: "Managementconclusie",
  cockpit_todo_appointment: "Afspraak",
  cockpit_todo_deadline: "Deadline",
  cockpit_todo_deadline_define: "Deadline instellen",
  pro_todo_status_acknowledged: "Bevestigd",
  pro_todo_responsible: "Verantwoordelijke",
  pro_todo_notice_confirmed: "Bevestigd in chat",
  pro_todo_notice_sent_at: "Bericht verzonden",
  pro_todo_notice_again: "Bericht opnieuw verzenden",
  pro_todo_notice_send: "Informeren via Kjuup-bericht",
  pro_todo_add_assignee: "Toevoegen",
  pro_todo_edit: "Bewerken",
  pro_todo_change_room: "Project wijzigen",
  pro_todo_due_on: "Vervalt op",
  pro_todo_edit_due: "Vervaldatum bewerken",
  pro_todo_no_date: "Zonder datum",
  pro_todo_edit_description: "Beschrijving bewerken",
  pro_todo_no_description: "Nog geen beschrijving",
  pro_todo_title_label: "Titel",
  pro_todo_title_placeholder: "Titel invoeren...",
  pro_todo_task: "Taak",
  pro_todo_what: "Wat moet er gebeuren?",
  pro_todo_source_email: "E-mail",
  pro_todo_sources: "Bronnen",
  previous: "Vorige",
  kjuup_plus_abo_tier_large: "Kjuup+ Large (tot {max} medewerkers)",
  kjuup_plus_abo_tier_small: "Kjuup+ Small (tot {max} medewerkers)",
  kjuup_plus_abo_status_ends: "Eindigt op {date}",
  kjuup_plus_abo_seats_over: "Meer dan {max} medewerkers – Kjuup neemt contact met u op met een aanbod op maat.",
  kjuup_plus_abo_seats_next: "Komen er meer medewerkers bij, dan schakelt het pakket automatisch over naar {next} (naar rato berekend).",
  kjuup_plus_abo_seats_used: "{used} van {total} plekken bezet",
  kjuup_plus_abo_seats_free: "Nog {count} plekken vrij",
  kjuup_plus_abo_intro_until: "tot {date}",
  kjuup_plus_abo_invoice_open: "Openstaand · vervalt op {date}",
  kjuup_plus_abo_invoices_all: "Alle {count} tonen",
  kjuup_plus_abo_requested_hint: "Opzegging aangevraagd op {date}. Kjuup bevestigt deze aan het einde van de looptijd ({end}).",
  kjuup_plus_abo_cancel_hint: "Kjuup beoordeelt uw aanvraag en bevestigt de opzegging aan het einde van de looptijd ({end}). Tot die tijd blijft Kjuup+ actief.",
  kjuup_plus_abo_withdrawn: "Opzeggingsaanvraag ingetrokken",
  kjuup_plus_abo_requested: "Opzegging aangevraagd",
  cockpit_upsell_plus_intro_hint: "eerste {months} maanden, daarna {price}",
  cockpit_upsell_plus_badge: "INTRODUCTIEPRIJS VOOR {months} MAANDEN",
  calendar_syncing: "Bijwerken vanuit kalender…",
  calendar_sync_up_to_date: "Kalender is actueel",
  calendar_sync_failed: "Synchronisatie mislukt",
  delete_multiple_tasks_confirm: "Weet je zeker dat je {count} ToDo's wilt verwijderen?",
  todos_deleted_count: "{count} ToDo's verwijderd",
  todos_deleted_partial: "{ok} ToDo's verwijderd, {fail} mislukt",
  todo_unknown: "Onbekend",
  todo_created_from_message: "Taak aangemaakt uit dit bericht",
  kjuup_io_todo_calendar_trial_ended_note: "Agendasynchronisatie · Abonneren",
  kjuup_io_todo_calendar_nudge: "Deze ToDo met uw agenda synchroniseren?",
  kjuup_io_todo_calendar_nudge_cta: "Kjuup.io activeren",
  todo_confirmed: "ToDo bevestigd",
  pro_todo_bulk_delete_title: "{{n}} taken verwijderen?",
  pro_todo_previous_none_own: "De achterstallige taken zijn door anderen aan u toegewezen en kunnen alleen door hen worden verwijderd.",
  pro_todo_previous_none: "Geen achterstallige taken",
  pro_todo_previous_title: "{{n}} achterstallige taken verwijderen?",
  pro_todo_previous_text: "Al uw open taken van eerdere dagen worden verwijderd.",
  pro_todo_previous_skipped: "{{n}} door anderen toegewezen taken blijven staan.",
  unassign_task_confirm: "Wilt u uw toewijzing aan deze taak ongedaan maken?",
  unassign_label: "Ongedaan maken",
  pro_todo_delete_title: "Taak verwijderen",
  pro_todo_today: "Vandaag",
  pro_todo_yesterday: "Gisteren",
  pro_todo_since_yesterday: "Sinds gisteren",
  pro_todo_mark_open: "Als open markeren",
  verify_completion: "Verifiëren",
  new_label: "Nieuw",
  bookmarked_no_mylist: "Gemarkeerde taken kunnen niet aan Mijn lijst worden toegevoegd",
  delete_only_own: "U kunt alleen taken verwijderen die u zelf hebt aangemaakt",
  todo_clear_all: "Alles wissen",
  pro_todo_of_completed: "{{done}} van {{total}} voltooid",
  pro_todo_pick_date: "Kies een datum",
  pro_todo_show_day: "Dag tonen",
  pro_todo_section_upcoming: "Aankomend",
  pro_todo_section_done: "Klaar",
  pro_todo_room_empty_today: "Vandaag geen taken in dit project",
  pro_todo_room_empty_day: "Op deze dag geen taken in dit project",
  pro_todo_delete_previous: "Alle verwijderen",
  pro_todo_empty_title: "Niets hier",
  pro_todo_empty_hint: "Geen taken komen overeen met deze weergave.",
  pro_todo_selected: "{{n}} geselecteerd",
  delete_selected_count: "Verwijderen ({count})",
  pro_todo_adjust_done: "Klaar",
  pro_todo_deleting: "Bezig met verwijderen...",
  pro_todo_reopen: "Taak heropenen",
  pro_todo_step_done: "Voltooid",
  move_back_in_progress: "Terug naar bezig",
  pro_todo_mark_not_started: "Markeren als niet gestart",
  back_into_in_progress: "Terug naar bezig",
  pro_todo_mark_in_progress: "Markeren als in uitvoering",
  unassign_todo: "ToDo toewijzing ongedaan maken",
  pro_todo_open_room: "Project openen",
  pro_todo_new_task: "Nieuwe taak",
  select_user_back_to_in_progress: "Selecteer de gebruiker die terug naar In uitvoering gaat",
  cockpit_email_accounts_n_many: "{{n}} accounts verbonden",
  // Kjuup + Microsoft Teams chats (new-chat pickers, combined groups)
  combined_tab_kjuup: "Kjuup-contacten",
  combined_tab_teams: "Teams-contacten",
  combined_bridge_failed: "De Teams-kopie kon niet worden gemaakt.",
  combined_chat_label: "Kjuup + Teams",
  combined_guest_tag: "Teams",
  combined_new_group_note: "Kjuup- en Teams-contacten: er wordt een nieuwe groep gemaakt die ook in Microsoft Teams verschijnt.",
  teams_new_chat_title: "Nieuwe Teams-chat",
  teams_new_chat_topic: "Groepsnaam (optioneel)",
  teams_new_chat_start: "Chat starten",
  teams_new_chat_creating: "Chat wordt gemaakt…",
  teams_new_chat_forbidden: "Microsoft Teams staat deze chat niet toe (bijv. een persoon buiten je organisatie of een beleid van je IT).",
  teams_new_chat_too_many: "Te veel personen voor één chat.",
  teams_new_chat_type_hint: "Typ een naam om in je organisatie te zoeken.",
  teams_new_chat_directory_forbidden: "Je organisatie staat zoeken in de directory niet toe. Alleen personen uit je Teams-chats worden getoond.",
  teams_new_chat_account: "Account",
};
